/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import moment from 'moment';
import { uniqueId, orderBy } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { AsyncCreatable } from 'react-select';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import Select from 'react-select';
import FlexBox from '../../../components/FlexBox';
import {
  makeSelectJSONVersion, makeSelectInsuredsList, makeSelectEmailAddressLogin, makeSelectIsClaimGroupAllowed, makeSelectPhoneNumberLogin, makeSelectShowZurichUHC, makeSelectPolicyPurchaseDate, makeSelectPolicyEffectiveDate, makeSelectPolicyTerminationDate,
  makeSelectIsClaimForFieldEnabled,
  makeSelectPolicyTypeCode,
  makeSelectPolicyPlanIds,
  makeSelectCarrier,
  makeSelectShowTrawickFNOLRefactoring,
  makeSelectCellCaptiveName,
  makeSelectFormHasChanges,
} from '../../App/selectors';
import {
  makeSelectFnolReportDateValidation,
  makeSelectAppClaimType,
  makeSelectValidationDateErrorMessage,
  makeSelectIsLinkedCover,
  makeSelectEventDescriptionLimit
} from '../../App/selectors';
import { makeSelectStepSupportingDocuments } from '../../FastCover/StepSupportingDocuments/selectors';
import {
  setSelectedPolicyId,
  setErrorMessageDateValidation,
  setFormHasChanges,
} from '../../App/actions';
import {
  makeSelectStepWhatHappened,
  makeSelectCountryList,
  makeSelectProvinceList,
  makeSelectClaimTypeList,
  makeSelectPolicyVersionChanged,
} from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import WizardNavigationButtons from '../components/WizardNavigationButtons';
import MySelect from '../../../components/MySelect';
import {
  handleFormDataChange,
  resetFormClaimToInjuryState,
  resetDetailOfMedicalConditional,
  getCityList,
  getProvinceList,
  getClaimTypes,
  checkValidationDateOfEvent,
  policyVersionChanged,
  deleteDocumentsByBenefitCode,
} from './actions';
import { setAuthenticationToken } from '../../Login/actions';
import { getCountryList, getCountriesOfxSupported } from './actions';
import DatePicker from '../components/DatePicker/index';
import TimePickerInput from '../../../components/TimePickerInput';
import TextArea from '../components/TextArea';
import { saveFormData } from '../actions';
import {
  getTitleList,
  getDepreciationTypes,
} from '../../ClaimList/actions';
import {
  required,
  checkEventDate,
  checkEventTime,
  checkDateOnly,
  validEmail,
  maxLength,
} from '../../../utils/validation/validator';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation/';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import injectSaga from '../../../utils/injectSaga';
import saga from './saga';
import FNOLTooltip from '../../../components/FNOLTooltip';
import Asterisk from '../../../components/Asterisk';
import HelpText from '../../../components/HelpText';
import {
  stepCancellationAdditionalExpenseLookup,
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepSnowSportsExpenseLookup,
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepCollisionDamageExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepAccidentalDeathAndDismembermentLookup,
  stepBaggageAndPersonalLookup,
  stepMissedConnectionLookup,
  stepSportsEquipmentLookup,
  stepMedicalExpenseCFLookup,
  stepTripCancellationCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  medicalHardshipLookup,
  jobLossHardshipLookup,
  disasterAssistanceHardshipLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  listCodeForDuesProtect,
  listNameBenefitForTripCan,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepChangesToYourJourneyTrawickLookup,
  stepBaggageAndPersonalItemsStarrLookup,
  stepOtherStarrLookup,
  stepCollisionDamageStarrLookup,
  stepMedicalExpensesTugoLookup,
  stepOtherTugoLookup,
  stepBaseVictorsMedicalTugoLookup,
  stepStudentMedicalBenefitsTugoLookup,
  stepTripCancellationTugoLookup,
  stepTripCancellationTravellerTugoLookup,
  stepTripInterruptionTugoLookup,
  stepTripInterruptionTravellerTugoLookup,
  stepADAndDTugoLookup,
  stepADAndDTravellerTugoLookup,
  stepBaggageAndPersonalItemsTravellerTugoLookup,
  stepRentalCarProtectionTravellerTugoLookup,
  stepStandardVTCMedicalBenefitsTugoLookup,
  stepTravellerMedicalBenefitsTugoLookup,
  stepOptimumMedicalBenefitsTugoLookup,
} from '../dataMapper/claimCodeMapper';
import { resetFormData as resetFormDataStepCancellationAdditional } from '../StepCancellationAdditional/actions';
import { resetFormData as resetFormDataStepPersonalItems } from '../StepPersonalItems/actions';
import { resetFormData as resetFormDataStepOverseasMedical } from '../StepOverseasMedical/actions';
import { resetFormData as resetFormDataStepRentalVehicle } from '../StepRentalVehicle/actions';
import { resetFormData as resetFormDataStepSnowSports } from '../StepSnowSports/actions';
import { resetFormData as resetFormDataStepOther } from '../StepOther/actions';
import { resetFormData as resetFormDataStep16 } from '../Step16/actions';
import { resetFormData as resetFormDataStep17 } from '../Step17/actions';
import { resetFormData as resetFormDataStepTripCancellationAndTripInterruption } from '../StepTripCancellationAndTripInterruption/actions';
import { resetFormData as resetFormDataStepBaggageAndPersonalItems } from '../StepBaggageAndPersonalItems/actions';
import { resetFormData as resetFormDataStepMedicalExpenses } from '../StepMedicalExpenses/actions';
import { resetFormData as resetFormDataStepCollisionDamage } from '../Trawick.NationWide.CollisionDamageStep/actions';
import { resetFormData as resetFormDataStepMedicalExpense } from '../Trawick.NationWide.MedicalExpenseStep/actions';
import { resetFormData as resetFormDataStepPetMedical } from '../Trawick.NationWide.PetMedicalStep/actions';
import { resetFormData as resetFormDataStepPropertyDamage } from '../Trawick.NationWide.PropertyDamageStep/actions';
import { resetFormData as resetFormDataStepTripCancellation } from '../Trawick.NationWide.TripCancellationStep/actions';
import { resetFormData as resetFormDataStepTripInterruption } from '../Trawick.NationWide.TripInterruptionStep/actions';
import { resetFormData as resetFormDataStepTripDelay } from '../Trawick.NationWide.TripDelayStep/actions';
import { resetFormData as resetFormDataStepAccidentalDeathAndDismemberment } from '../Trawick.NationWide.AccidentalDeathAndDismembermentStep/actions';
import { resetFormData as resetFormDataStepMissedConnection } from '../Trawick.NationWide.MissedConnectionStep/actions';
import { resetFormData as resetFormDataStepBaggageAndPersonal } from '../Trawick.NationWide.PersonalItemStep/actions';
import { resetFormData as resetFormDataStepSportsEquipment } from '../Trawick.NationWide.SportsEquipmentStep/actions';
import { resetFormData as resetFormDataStepMedicalExpenseCF } from '../Trawick.CFTripCan.MedicalExpense/actions';
import { resetFormData as resetFormDataStepMedicalExpenseZurich } from '../Trawick.Zurich.MedicalExpense/actions';
import { resetFormData as resetFormDataStepTripCancellationCF } from '../Trawick.CFTripCan.TripCancellationStep/actions';
import { resetFormData as resetFormDataStepBaggagePersonalEffects } from '../Trawick.CFTripCan.BaggagePersonalEffects/actions';
import { resetFormData as resetFormDataStepItineraryChange } from '../Trawick.CFTripCan.ItineraryChange/actions';
import { resetFormData as resetFormDataStepMedicalHardship } from '../Trawick.DuesProtect.MedicalHardshipStep/actions';
import { resetFormData as resetFormDataStepJobLossHardship } from '../Trawick.DuesProtect.JobLossHardshipStep/actions';
import { resetFormData as resetFormDataStepDisasterAssistanceHardship } from '../Trawick.DuesProtect.DisasterAssistanceHardshipStep/actions';
import { resetFormData as resetFormDataTravelDelay } from '../StepTravelDelay/actions';
import { resetFormData as resetFormDataMedicalAndEvacuationSCTI } from '../Trawick.SCTI.MedicalAndEvacuation/actions';
import { resetFormData as resetFormDataChangesToYourJourneySCTI } from '../Trawick.SCTI.ChangesToYourJourney/actions';
import { resetFormData as resetFormDataBaggageAndPersonalItemsSCTI } from '../Trawick.SCTI.BaggageAndPersonalItems/actions';
import { resetFormData as resetFormDataCashBankCardsTravelDocumentsAndPassports } from '../Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/actions';
import { resetFormData as resetFormDataPersonalAccidentSCTI } from '../Trawick.SCTI.PersonalAccident/actions';
import { resetFormData as resetFormDataRentalVehicleExcessSCTI } from '../Trawick.SCTI.RentalVehicleExcess/actions';
import { resetFormData as resetFormDataChangesToYourJourney } from '../Trawick.ChangesToYourJourney/actions';
import { resetFormData as resetFormDataBaggageAndPersonalItemsStarr } from '../Trawick.Starr.StepBaggageAndPersonalItems/actions';
import { resetFormData as resetFormDataOtherStarrStarr } from '../Trawick.Starr.StepOther/actions';
import { resetFormData as resetFormCollisionDamageStarr } from '../Trawick.Starr.StepCollisionDamage/actions';
import { resetFormData as resetFormDataMedicalExpensesTugo } from '../Tugo.MedicalExpenses/actions';
import { resetFormData as resetFormDataOtherTugo } from '../Tugo.StepOther/actions';
import { resetFormData as resetFormDataBaseVictorsMedicalTugo } from '../Tugo.BaseVictorsMedical/actions';
import { resetFormData as resetFormDataStudentMedicalBenefitsTugo } from '../Tugo.StudentMedicalBenefits/actions';
import { resetFormData as resetFormDataTripCancellationTugo } from '../Tugo.TripCancellation/actions';
import { resetFormData as resetFormDataTripInterruptionTugo } from '../Tugo.TripInterruption/actions';
import { resetFormData as resetFormDataStandardVTCMedicalBenefitsTugo } from '../Tugo.StandardVTCMedicalBenefits/actions';
import { resetFormData as resetFormDataTravellerMedicalBenefitsTugo } from '../Tugo.TravellerMedicalBenefits/actions';
import { resetFormData as resetFormDataOptimumMedicalBenefitsTugo } from '../Tugo.OptimumMedicalBenefits/actions';
import { resetFormData as resetFormDataADAndDBenefitsTugo } from '../Tugo.ADAndDBenefits/actions';
import { resetFormData as resetFormDataTripCancellationTravellerTugo } from '../Tugo.TripCancellationTraveller/actions';
import { resetFormData as resetFormDataBaggageAndPersonalItemsTravellerTugo } from '../Tugo.BaggageAndPersonalItemsTraveller/actions';
import { resetFormData as resetFormDataRentalCarProtectionTravellerTugo } from '../Tugo.RentalCarProtectionTraveller/actions';
import { removeFileSuccess } from '../StepSupportingDocuments/actions';
import { redirectTo } from '../../PrivateRoute/actions';
import routeConfig from '../../../utils/routeConfig';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import EventDateWarning from './components/EventDateWarning';
import PolicyVersionChangeWarning from './components/PolicyVersionChangeWarning';
import CurrencySelector from '../components/CurrencySelector';
import Textbox from '../components/Textbox';
import OptionsContainer from '../components/OptionsContainer';
import P from '../../../components/P';
import { appConfig } from '../../../configureApp';
import { LIST_CELLCAPTIVE_NAME } from '../../App/constants';
import { LIST_POLICY_TYPE_CODE } from '../../App/constants';

const normalizeBenefitKey = (value = '') => value
  .replace(/&/g, ' ')
  .replace(/[^A-Za-z0-9]+/g, ' ')
  .trim()
  .split(' ')
  .filter((word) => word.length > 0)
  .map((word, index) => {
    const lower = word.toLowerCase();
    if (index === 0) {
      return lower;
    }
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  })
  .join('');

const getBenefitMessageId = (description = '') => {
  const normalized = normalizeBenefitKey(description);
  return normalized ? `fastCover.fastCoverWizard.${normalized}` : null;
};

const formatBenefitDescription = (intl, description = '') => {
  const messageId = getBenefitMessageId(description);
  if (!messageId || !intl || typeof intl.formatMessage !== 'function') {
    return description;
  }

  return intl.formatMessage({ id: messageId, defaultMessage: description });
};

const PROVINCE_MESSAGE_IDS = {
  BC: 'fastCover.province.britishColumbia',
  'British Columbia': 'fastCover.province.britishColumbia',
  NB: 'fastCover.province.newBrunswick',
  'New Brunswick': 'fastCover.province.newBrunswick',
  NL: 'fastCover.province.newfoundlandAndLabrador',
  'Newfoundland and Labrador': 'fastCover.province.newfoundlandAndLabrador',
  NT: 'fastCover.province.northwestTerritories',
  'Northwest Territories': 'fastCover.province.northwestTerritories',
  NS: 'fastCover.province.novaScotia',
  'Nova Scotia': 'fastCover.province.novaScotia',
  PE: 'fastCover.province.princeEdwardIsland',
  PEI: 'fastCover.province.princeEdwardIsland',
  'Prince Edward Island': 'fastCover.province.princeEdwardIsland',
  QC: 'fastCover.province.quebec',
  Quebec: 'fastCover.province.quebec',
};

const formatProvinceOption = (intl, provinceOption = {}) => {
  const messageId = PROVINCE_MESSAGE_IDS[provinceOption.code] || PROVINCE_MESSAGE_IDS[provinceOption.label];

  if (!messageId || !intl || typeof intl.formatMessage !== 'function') {
    return provinceOption;
  }

  return {
    ...provinceOption,
    label: intl.formatMessage({ id: messageId, defaultMessage: provinceOption.label }),
  };
};

const CITY_SEARCH_DEBOUNCE_MS = 500;

export class StepWhatHappened extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      timeValidateCounter: 0,
      showModal: false,
      errorMessageValidation: '',
    };

    this.validatorGroup = new ValidateGroup();

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
    this.loadCityTimer = null;

    this.onResize = this.onResize.bind(this);

    this.currentEventDate = props.form.dateOfEvent;
    this.currentEventTime = props.form.timeOfEvent;
  }

  componentDidMount() {
    if (!this.props.isSummary) {
      this.props.getCountryList();
      this.props.getCountriesOfxSupported();
      // get province if have country
      if (this.props.form.country) {
        this.props.getProvinceList();
      }

      this.props.getClaimTypes();
    }
    else if (this.props.token) {
      this.props.setToken(this.props.token);

      this.props.getCountryList();
      this.props.getCountriesOfxSupported();
      if (this.props.form.country) {
        this.props.getProvinceList();
      }
      this.props.setSelectedPolicyId(this.props.policyNumber);

      this.props.getClaimTypes();
      this.props.getTitleList();
      this.props.getDepreciationTypes();
    }

    if (this.props.path === '/wizard' && !this.props.submitted) {
      this.handleFormDataSave();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;

    if (
      (stepName && nextProps.validateStep === stepName) ||
      (currentStep !== nextProps.currentStep && currentStep === step)
    ) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }

    if (
      this.props.isSummary &&
      this.props.appClaimTypes.length !== nextProps.appClaimTypes.length
    ) {
      this.props.getClaimTypes();
    }

    if (nextProps.errorMessage.length > 0) {
      this.showModal();
      this.checkFormError();
    }
  }

  componentWillUnmount() {
    if (this.loadCityTimer) {
      clearTimeout(this.loadCityTimer);
    }
  }

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };
  onChangeBenefit = (d, evt) => {
    const { selectedBenefits } = this.props.form;
    const selected =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];

    let tmp = _.cloneDeep(selected);
    const target = evt.target;

    if (target.checked) {
      tmp.push(d);
    }
    else {
      tmp = tmp.filter((v) => v.claimTypeId !== d.claimTypeId);
      this.resetFormData(d.claimCode, d.claimTypeId);
    }

    this.props.onFormDataChange('form.selectedBenefits', tmp);
    this.props.setFormHasChanges(true);
  };

  onChange = (propertyName) => (event) => {
    const { timeOfEvent } = this.props.form;
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      this.props.setFormHasChanges(true);
      return;
    }
    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(
        propertyName,
        removeTimeZoneFromDate(event.toDate().toString())
      );
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      this.props.onFormDataChange(propertyName, value);
    }
    if (propertyName === 'form.timeOfEvent') {
      this.currentEventTime = timeOfEvent;
    }
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(4);
  };

  getCitySelectKey = (selectedCountry, province = '') => {
    const countryOption = selectedCountry && typeof selectedCountry.toJS === 'function'
      ? selectedCountry.toJS()
      : selectedCountry;
    const countryValue = countryOption && typeof countryOption === 'object'
      ? countryOption.id || countryOption.value || countryOption.label
      : countryOption;

    return `${countryValue || 'none'}-${province || 'none'}`;
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  }

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.handleFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }
    this.checkFormError();
    this.handleFormDataSave();
    this.props.next();
  };

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();

    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  checkTimeCallBack = () => {
    this.props.checkValidationDateOfEvent('form.timeOfEvent');
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
      this.props.setFormHasChanges(true);
    }
  };

  handleDayChange = (propertyName) => (day) => {
    const { dateOfEvent } = this.props.form;

    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
    this.props.setFormHasChanges(true);
    if (propertyName === 'form.dateOfEvent') {
      this.currentEventDate = dateOfEvent;
      this.props.checkValidationDateOfEvent(propertyName);
      setTimeout(() => {
        this.setState({
          timeValidateCounter: this.state.timeValidateCounter + 1,
        });
      }, 400);
    }
  };

  handleChange = (propertyName) => (event) => {
    const { form, isSummary, emailAddressLogin, phoneNumberLogin } = this.props;
    const { selectedClaimFor } = isSummary ? this.summaryFormValue() : form;
    const selectedClaimForList = selectedClaimFor ? selectedClaimFor.toJS ? selectedClaimFor.toJS() : selectedClaimFor : [];
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (target.type === 'radio') {
      this.props.adjust();
    }

    if (propertyName === 'form.usePrimaryMemberEmailAddressForAllMember') {
      const updatedSelectedClaimForList = selectedClaimForList.map((insured) => ({
        ...insured,
        email: value === true ? emailAddressLogin : '',
      }));
      this.props.onFormDataChange('form.selectedClaimFor', updatedSelectedClaimForList);
    }

    if (propertyName === 'form.usePrimaryMemberPhoneNumberForAllMember') {
      const updatedSelectedClaimForList = selectedClaimForList.map((insured) => ({
        ...insured,
        phoneNumber: value === true ? phoneNumberLogin : '',
      }));
      this.props.onFormDataChange('form.selectedClaimFor', updatedSelectedClaimForList);
    }

    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(4);
  };

  handleChangeCountry = (v) => {
    const isScti = appConfig.reactAppEnv === 'scti';
    let countryValue = v;

    if (v && typeof v === 'object' && v.value) {
      countryValue = v.value;
    }

    if (v === null) {
      this.props.onFormDataChange('form.selectedCountry', v);
      this.props.onFormDataChange('form.country', v);
    } else if (typeof v === 'object') {
      this.props.onFormDataChange('form.selectedCountry', v);
    } else {
      this.props.onFormDataChange('form.country', v);
      this.props.onFormDataChange('form.selectedCountry', v);
    }

    // Reset city and province values and fetch lists if a country is selected
    this.props.onFormDataChange('form.city', '');
    this.props.onFormDataChange('form.province', '');
    if (countryValue && !isScti) {
      this.props.getProvinceList();
    }
    this.props.setFormHasChanges(true);
  };

  handleChangeInsureds = (selectedClaimFor) => {
    if (selectedClaimFor) {
      this.props.onFormDataChange('form.selectedClaimFor', selectedClaimFor);
      this.props.setFormHasChanges(true);
    }
  };

  handleResetPartialFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  loadCity = (inputValue, callback) => {
    const searchValue = (inputValue || '').trim();

    if (this.loadCityTimer) {
      clearTimeout(this.loadCityTimer);
    }

    this.loadCityTimer = setTimeout(() => {
      this.props.getCityList(searchValue, callback);
    }, CITY_SEARCH_DEBOUNCE_MS);
  };

  cityNoOptionsMessage = () => this.props.intl.formatMessage(messages.noCitiesFound);

  loadCountry = (inputValue, callback) => {
    const {
      countryList,
    } = this.props;
    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];
    const countryListFiltered = countries.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
    setTimeout(() => {
      callback(countryListFiltered);
    }, 1000);
  };

  resetFormData = (code, _claimTypeId) => {
    const { showZurichUHC, jsonVersion } = this.props;

    const newVersion = jsonVersion > 11;
    const newVersionForOtherCollision = jsonVersion > 12;
    let stepTravelDelayList = stepTravelDelayLookup.claimCodeList;
    let stepTripCancellationAndTripInterruptionExpenseList = stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList;
    let stepChangesToYourJourneyTrawickList = stepChangesToYourJourneyTrawickLookup.claimCodeList;

    let stepMedicalExpensesList = stepMedicalExpensesExpenseLookup.claimCodeList;
    let stepMedicalExpensesTrawickList = stepMedicalExpenseCFLookup.claimCodeList;
    let stepBaggageAndPersonalItemsList = stepBaggageAndPersonalItemsExpenseLookup.claimCodeList;
    let stepBaggageAndPersonalItemsStarrList = stepBaggageAndPersonalItemsStarrLookup.claimCodeList;
    let stepOtherClaimCodeList = stepOtherExpenseLookup.claimCodeList;
    let stepOtherStarrList = stepOtherStarrLookup.claimCodeList;
    let stepCollisionDamageList = stepCollisionDamageExpenseLookup.claimCodeList;
    let stepCollisionDamageStarrList = stepCollisionDamageStarrLookup.claimCodeList;

    if (newVersion) {
      stepMedicalExpensesList = stepMedicalExpensesList.filter((x) => !stepMedicalExpensesTrawickList.includes(x));
      stepTravelDelayList = stepTravelDelayList.filter((x) => !stepChangesToYourJourneyTrawickList.includes(x));
      stepTripCancellationAndTripInterruptionExpenseList = stepTripCancellationAndTripInterruptionExpenseList.filter((x) => !stepChangesToYourJourneyTrawickList.includes(x));
    } else {
      stepChangesToYourJourneyTrawickList = stepChangesToYourJourneyTrawickList.filter((x) => !stepTravelDelayList.includes(x) && !stepTripCancellationAndTripInterruptionExpenseList.includes(x));
      stepMedicalExpensesTrawickList = stepMedicalExpensesTrawickList.filter((x) => !stepMedicalExpensesList.includes(x));
    }

    if (newVersionForOtherCollision) {
      stepBaggageAndPersonalItemsList = stepBaggageAndPersonalItemsList.filter((x) => !stepBaggageAndPersonalItemsStarrList.includes(x));
      stepOtherClaimCodeList = stepOtherClaimCodeList.filter((x) => !stepOtherStarrList.includes(x));
      stepCollisionDamageList = stepCollisionDamageList.filter((x) => !stepCollisionDamageStarrList.includes(x));
    } else {
      stepBaggageAndPersonalItemsStarrList = stepBaggageAndPersonalItemsStarrList.filter((x) => !stepBaggageAndPersonalItemsList.includes(x));
      stepOtherStarrList = stepOtherStarrList.filter((x) => !stepOtherClaimCodeList.includes(x));
      stepCollisionDamageStarrList = stepCollisionDamageStarrList.filter((x) => !stepCollisionDamageList.includes(x));
    }

    const isStepCancellationAdditional =
      stepCancellationAdditionalExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepPersonalItems =
      stepPersonalItemsExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepOverseasMedical =
      stepOverseasMedicalExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepRentalVehicle =
      stepRentalVehicleExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepSnowSports =
      stepSnowSportsExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepOther =
      stepOtherExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepTripCancellationAndTripInterruption =
      stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepBaggageAndPersonalItems =
      stepBaggageAndPersonalItemsList.filter((d) => d === code)
        .length > 0;
    const isStepMedicalExpenses =
      stepMedicalExpensesExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepPetMedical =
      stepPetMedicalExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepCollisionDamage =
      stepCollisionDamageList.filter((d) => d === code)
        .length > 0;
    const isStepPropertyDamage =
      stepPropertyDamageExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepMedicalExpense =
      stepMedicalExpenseLookup.claimCodeList.filter((d) => d === code)
        .length > 0 && !showZurichUHC;
    const isStepTripCancellation =
      stepTripCancellationLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepADAndD =
      stepAccidentalDeathAndDismembermentLookup.claimCodeList.filter((d) => d === code)
        .length > 0;
    const isStepTripInterruption =
      stepTripInterruptionLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepTripDelay =
      stepTripDelayLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMissedConnection =
      stepMissedConnectionLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepBaggageAndPersonal =
      stepBaggageAndPersonalLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepSportsEquipment =
      stepSportsEquipmentLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMedicalExpenseCF =
      stepMedicalExpensesTrawickList.filter((d) => d === code).length > 0;
    const isStepMedicalExpenseZurich =
      stepMedicalExpensesList.filter((d) => d === code).length > 0 && showZurichUHC;
    const isStepTripCancellationCF =
      stepTripCancellationCFLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepBaggagePersonalEffects =
      baggagePersonalEffectsLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepItineraryChange =
      itineraryChangeLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMedicalHardship =
      medicalHardshipLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepJobLossHardship =
      jobLossHardshipLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepDisasterAssistanceHardship =
      disasterAssistanceHardshipLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepTravelDelay =
      stepTravelDelayList.filter((d) => d === code).length > 0;
    const isMedicalAndEvacuation =
      stepMedicalAndEvacuationLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isChangesToYourJourneySCTI =
      stepChangesToYourJourneyLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isBaggageAndPersonalItemsSCTI =
      stepBaggageAndPersonalItemsSCTILookup.claimCodeList.filter((d) => d === code).length > 0;
    const isCashBankCardsTravelDocumentsAndPassports =
      stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isPersonalAccidentSCTI =
      stepPersonalAccidentSCTILookup.claimCodeList.filter((d) => d === code).length > 0;
    const isRentalVehicleExcessSCTI =
      stepRentalVehicleExcessSCTILookup.claimCodeList.filter((d) => d === code).length > 0;
    const isChangesToYourJourney =
      stepChangesToYourJourneyTrawickList.filter((d) => d === code).length > 0;
    const isBaggageAndPersonalItemsStarr =
      stepBaggageAndPersonalItemsStarrList.filter((d) => d === code).length > 0;
    const isStepOtherStarr =
      stepOtherStarrList.filter((d) => d === code).length > 0;
    const isCollisionDamageStarr =
      stepCollisionDamageStarrList.filter((d) => d === code).length > 0;
    const isMedicalExpensesTugo =
      stepMedicalExpensesTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isOtherTugo =
      stepOtherTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isBaseVictorsMedicalTugo =
      stepBaseVictorsMedicalTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStudentMedicalBenefitsTugo =
      stepStudentMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isTripCancellationTugo =
      stepTripCancellationTugoLookup.claimCodeList.filter((d) => d === code).length > 0
      || stepTripCancellationTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isTripInterruptionTugo =
      stepTripInterruptionTugoLookup.claimCodeList.filter((d) => d === code).length > 0
      || stepTripInterruptionTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isADAndDTugo =
      stepADAndDTugoLookup.claimCodeList.filter((d) => d === code).length > 0
      || stepADAndDTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isBaggageAndPersonalItemsTravellerTugo =
      stepBaggageAndPersonalItemsTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isRentalCarProtectionTravellerTugo =
      stepRentalCarProtectionTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStandardVTCMedicalBenefitsTugo =
      stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isTravellerMedicalBenefitsTugo =
      stepTravellerMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isOptimumMedicalBenefitsTugo =
      stepOptimumMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;

    if (isStepCancellationAdditional) {
      this.props.resetFormDataStepCancellationAdditional();
    } if (isStepPersonalItems) {
      this.props.resetFormDataStepPersonalItems();
    } if (isStepOverseasMedical) {
      this.props.resetFormDataStepOverseasMedical();
    } if (isStepRentalVehicle) {
      this.props.resetFormDataStepRentalVehicle();
    } if (isStepSnowSports) {
      this.props.resetFormDataStepSnowSports();
    } if (isStepOther) {
      this.props.resetFormDataStepOther();
    } if (isStepTripCancellationAndTripInterruption) {
      this.props.resetFormDataStepTripCancellationAndTripInterruption();
    } if (isStepBaggageAndPersonalItems) {
      this.props.resetFormDataStepBaggageAndPersonalItems();
    } if (isStepMedicalExpenses) {
      this.props.resetFormDataStepMedicalExpenses();
    } if (isStepPetMedical) {
      this.props.resetFormDataStepPetMedical();
    } if (isStepCollisionDamage) {
      this.props.resetFormDataStepCollisionDamage();
    } if (isStepPropertyDamage) {
      this.props.resetFormDataStepPropertyDamage();
    } if (isStepMedicalExpense) {
      this.props.resetFormDataStepMedicalExpense();
    } if (isStepTripCancellation) {
      this.props.resetFormDataStepTripCancellation();
    } if (isTripCancellationTugo) {
      this.props.resetFormDataTripCancellationTugo();
      this.props.resetFormDataTripCancellationTravellerTugo();
      this.props.resetFormDataTripInterruptionTugo();
    } if (isStepADAndD) {
      this.props.resetFormDataStepAccidentalDeathAndDismemberment();
    } if (isStepTripInterruption) {
      this.props.resetFormDataStepTripInterruption();
    } if (isStepTripDelay) {
      this.props.resetFormDataStepTripDelay();
    } if (isStepMissedConnection) {
      this.props.resetFormDataStepMissedConnection();
    } if (isStepBaggageAndPersonal) {
      this.props.resetFormDataStepBaggageAndPersonal();
    } if (isStepSportsEquipment) {
      this.props.resetFormDataStepSportsEquipment();
    } if (isStepMedicalExpenseCF) {
      this.props.resetFormDataStepMedicalExpenseCF();
    } if (isStepMedicalExpenseZurich) {
      this.props.resetFormDataStepMedicalExpenseZurich();
    } if (isStepTripCancellationCF) {
      this.props.resetFormDataStepTripCancellationCF();
    } if (isStepBaggagePersonalEffects) {
      this.props.resetFormDataStepBaggagePersonalEffects();
    } if (isStepItineraryChange) {
      this.props.resetFormDataStepItineraryChange();
    } if (isStepMedicalHardship) {
      this.props.resetFormDataStepMedicalHardship();
    } if (isStepJobLossHardship) {
      this.props.resetFormDataStepJobLossHardship();
    } if (isStepDisasterAssistanceHardship) {
      this.props.resetFormDataStepDisasterAssistanceHardship();
    } if (isStepTravelDelay) {
      this.props.resetFormDataTravelDelay();
    } if (isMedicalAndEvacuation) {
      this.props.resetFormDataMedicalAndEvacuationSCTI();
    } if (isChangesToYourJourneySCTI) {
      this.props.resetFormDataChangesToYourJourneySCTI();
    } if (isBaggageAndPersonalItemsSCTI) {
      this.props.resetFormDataBaggageAndPersonalItemsSCTI();
    } if (isPersonalAccidentSCTI) {
      this.props.resetFormDataPersonalAccidentSCTI();
    } if (isRentalVehicleExcessSCTI) {
      this.props.resetFormDataRentalVehicleExcessSCTI();
    } if (isCashBankCardsTravelDocumentsAndPassports) {
      this.props.resetFormDataCashBankCardsTravelDocumentsAndPassports();
    } if (isChangesToYourJourney) {
      this.props.resetFormDataChangesToYourJourney();
    } if (isBaggageAndPersonalItemsStarr) {
      this.props.resetFormDataBaggageAndPersonalItemsStarr();
    } if (isStepOtherStarr) {
      this.props.resetFormDataOtherStarrStarr();
    } if (isCollisionDamageStarr) {
      this.props.resetFormCollisionDamageStarr();
    } if (isMedicalExpensesTugo) {
      this.props.resetFormDataMedicalExpensesTugo();
    } if (isOtherTugo) {
      this.props.resetFormDataOtherTugo();
    } if (isBaseVictorsMedicalTugo) {
      this.props.resetFormDataBaseVictorsMedicalTugo();
    } if (isStudentMedicalBenefitsTugo) {
      this.props.resetFormDataStudentMedicalBenefitsTugo();
    } if (isTripCancellationTugo) {
      this.props.resetFormDataTripCancellationTugo();
      this.props.resetFormDataTripCancellationTravellerTugo();
    } if (isTripInterruptionTugo) {
      this.props.resetFormDataTripInterruptionTugo();
    } if (isADAndDTugo) {
      this.props.resetFormDataADAndDBenefitsTugo();
    } if (isBaggageAndPersonalItemsTravellerTugo) {
      this.props.resetFormDataBaggageAndPersonalItemsTravellerTugo();
    } if (isRentalCarProtectionTravellerTugo) {
      this.props.resetFormDataRentalCarProtectionTravellerTugo();
    } else if (isStandardVTCMedicalBenefitsTugo) {
      this.props.resetFormDataStandardVTCMedicalBenefitsTugo();
    } else if (isTravellerMedicalBenefitsTugo) {
      this.props.resetFormDataTravellerMedicalBenefitsTugo();
      this.props.resetFormDataADAndDBenefitsTugo();
    } if (isOptimumMedicalBenefitsTugo) {
      this.props.resetFormDataOptimumMedicalBenefitsTugo();
      this.props.resetFormDataADAndDBenefitsTugo();
    }
    // need to remove files if uploaded
    const removedFileList = this.props.makeSelectStepSupportingDocuments.attachDocuments.filter(
      (d) => d.benefitCode === code
    );
    this.props.deleteDocumentsByBenefitCode(code);
    removedFileList.forEach((f) => {
      this.props.removeFileSuccess(f);
    });
  };

  closeModal = () => {
    this.setState({ showModal: false });
    this.props.onFormDataChange('form.timeOfEvent', null);
    this.props.onFormDataChange('form.selectedBenefits', []);
    this.props.setErrorMessageDateValidation('');
  };

  proceedAnyway = () => {
    this.setState({ showModal: false });
    this.props.setErrorMessageDateValidation('');
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  closePolicyVersionChangeModal = (result) => {
    this.props.policyVersionChanged(false);
    if (result) {
      this.resetSelectedBenefits();
      this.props.getClaimTypes();
    } else {
      this.resetEventDateTime();
    }
  };

  resetSelectedBenefits = () => {
    this.props.onFormDataChange('form.selectedBenefits', []);
  };

  resetEventDateTime = () => {
    this.props.onFormDataChange('form.dateOfEvent', this.currentEventDate);
    this.props.onFormDataChange('form.timeOfEvent', this.currentEventTime);
  };

  renderBenefitImage = (code) => {
    const { showZurichUHC } = this.props;

    const isStepCancellationAdditional =
      stepCancellationAdditionalExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepPersonalItems =
      stepPersonalItemsExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepOverseasMedical =
      stepOverseasMedicalExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepRentalVehicle =
      stepRentalVehicleExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepTripCancellationAndTripInterruption =
      stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepBaggageAndPersonalItems =
      stepBaggageAndPersonalItemsExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMedicalExpenses =
      stepMedicalExpensesExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepPetMedical =
      stepPetMedicalExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepCollisionDamage =
      stepCollisionDamageExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepPropertyDamage =
      stepPropertyDamageExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMedicalExpense =
      stepMedicalExpenseLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepTripCancellation =
      stepTripCancellationLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepADAndD =
      stepAccidentalDeathAndDismembermentLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepTripInterruption =
      stepTripInterruptionLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepTripDelay =
      stepTripDelayLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMissedConnection =
      stepMissedConnectionLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepBaggageAndPersonal =
      stepBaggageAndPersonalLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepSportsEquipment =
      stepSportsEquipmentLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMedicalExpenseCF =
      stepMedicalExpenseCFLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMedicalExpenseZurich =
      stepMedicalExpenseCFLookup.claimCodeList.filter((d) => d === code).length > 0 && showZurichUHC;
    const isStepTripCancellationCF =
      stepTripCancellationCFLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepBaggagePersonalEffects =
      baggagePersonalEffectsLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepItineraryChange =
      itineraryChangeLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepMedicalHardship =
      medicalHardshipLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepJobLossHardship =
      jobLossHardshipLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepDisasterAssistanceHardship =
      disasterAssistanceHardshipLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepTravelDelay =
      stepTravelDelayLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isMedicalAndEvacuation =
      stepMedicalAndEvacuationLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isChangesToYourJourneySCTI =
      stepChangesToYourJourneyLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isBaggageAndPersonalItemsSCTI =
      stepBaggageAndPersonalItemsSCTILookup.claimCodeList.filter((d) => d === code).length > 0;
    const isCashBankCardsTravelDocumentsAndPassports =
      stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isPersonalAccidentSCTI =
      stepPersonalAccidentSCTILookup.claimCodeList.filter((d) => d === code).length > 0;
    const isRentalVehicleExcessSCTI =
      stepRentalVehicleExcessSCTILookup.claimCodeList.filter((d) => d === code).length > 0;
    const isChangesToYourJourney =
      stepChangesToYourJourneyTrawickLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isBaggageAndPersonalItemsStarr =
      stepBaggageAndPersonalItemsStarrLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStepOtherStarr =
      stepOtherStarrLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isCollisionDamageStarr =
      stepCollisionDamageStarrLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isMedicalExpensesTugo =
      stepMedicalExpensesTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isOtherTugo =
      stepOtherTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isBaseVictorsMedicalTugo =
      stepBaseVictorsMedicalTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStudentMedicalBenefitsTugo =
      stepStudentMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isTripCancellationTugo =
      stepTripCancellationTugoLookup.claimCodeList.filter((d) => d === code).length > 0
      || stepTripCancellationTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isTripInterruptionTugo =
      stepTripInterruptionTugoLookup.claimCodeList.filter((d) => d === code).length > 0
      || stepTripInterruptionTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isStandardVTCMedicalBenefitsTugo =
      stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isTravellerMedicalBenefitsTugo =
      stepTravellerMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isOptimumMedicalBenefitsTugo =
      stepOptimumMedicalBenefitsTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isBaggageAndPersonalItemsTravellerTugo =
      stepBaggageAndPersonalItemsTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    const isRentalCarProtectionTravellerTugo =
      stepRentalCarProtectionTravellerTugoLookup.claimCodeList.filter((d) => d === code).length > 0;
    // const isStepSnowSports = (Object.values(stepSnowSports ExpenseLookup).filter((d) => d.claimCode === code)).length > 0;
    // const isStepOther = (Object.values(stepOtherExpenseLook  up).filter((d) => d.claimCode === code)).length > 0;
    let src = '';
    if (isStepCancellationAdditional) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStepPersonalItems) {
      src = '/Luggage-gray.png';
    } else if (isStepOverseasMedical) {
      src = '/Medical-gray.png';
    } else if (isStepRentalVehicle) {
      src = '/Trip-Distruption-gray.png';
    } else if (isStepTripCancellationAndTripInterruption) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStepBaggageAndPersonalItems) {
      src = '/Luggage-gray.png';
    } else if (isStepMedicalExpenses) {
      src = '/Medical-gray.png';
    } else if (isStepPetMedical) {
      src = '/Medical-gray.png';
    } else if (isStepCollisionDamage) {
      src = '/Luggage-gray.png';
    } else if (isStepPropertyDamage) {
      src = '/Luggage-gray.png';
    } else if (isStepMedicalExpense) {
      src = '/Medical-gray.png';
    } else if (isStepTripCancellation) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStepADAndD) {
      src = '/Other-gray.png';
    } else if (isStepTripInterruption) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStepTripDelay) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStepMissedConnection) {
      src = '/Other-gray.png';
    } else if (isStepBaggageAndPersonal) {
      src = '/Other-gray.png';
    } else if (isStepSportsEquipment) {
      src = '/Other-gray.png';
    } else if (isStepMedicalExpenseCF) {
      src = '/Other-gray.png';
    } else if (isStepMedicalExpenseZurich) {
      src = '/Other-gray.png';
    } else if (isStepTripCancellationCF) {
      src = '/Other-gray.png';
    } else if (isStepBaggagePersonalEffects) {
      src = '/Other-gray.png';
    } else if (isStepItineraryChange) {
      src = '/Other-gray.png';
    } else if (isStepMedicalHardship) {
      src = '/Other-gray.png';
    } else if (isStepJobLossHardship) {
      src = '/Other-gray.png';
    } else if (isStepDisasterAssistanceHardship) {
      src = '/Other-gray.png';
    } else if (isStepTravelDelay) {
      src = '/Other-gray.png';
    } else if (isMedicalAndEvacuation) {
      src = '/Medical-gray.png';
    } else if (isChangesToYourJourneySCTI) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isBaggageAndPersonalItemsSCTI) {
      src = '/Luggage-gray.png';
    } else if (isPersonalAccidentSCTI) {
      src = '/Medical-gray.png';
    } else if (isRentalVehicleExcessSCTI) {
      src = '/Rental-Vehicle.png';
    } else if (isCashBankCardsTravelDocumentsAndPassports) {
      src = '/Cash-and-Bank-Cards.png';
    } else if (isChangesToYourJourney) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isBaggageAndPersonalItemsStarr) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStepOtherStarr) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isCollisionDamageStarr) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isMedicalExpensesTugo) {
      src = '/Medical-gray.png';
    } else if (isOtherTugo) {
      src = '/Other-gray.png';
    } else if (isBaseVictorsMedicalTugo) {
      src = '/Medical-gray.png';
    } else if (isStudentMedicalBenefitsTugo) {
      src = '/Medical-gray.png';
    } else if (isTripCancellationTugo) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isTripInterruptionTugo) {
      src = '/Trip-Cancellation-gray.png';
    } else if (isStandardVTCMedicalBenefitsTugo) {
      src = '/Medical-gray.png';
    } else if (isTravellerMedicalBenefitsTugo) {
      src = '/Medical-gray.png';
    } else if (isOptimumMedicalBenefitsTugo) {
      src = '/Medical-gray.png';
    } else if (isBaggageAndPersonalItemsTravellerTugo) {
      src = '/Luggage-gray.png';
    } else if (isRentalCarProtectionTravellerTugo) {
      src = '/Rental-Vehicle.png';
    } else {
      src = '/Other-gray.png';
    }
    return (
      <img alt={'benefit logo'} className={'d-inline'} width={100} src={src} />
    );
  };
  renderBenefit = (isReadOnly) => {
    const { claimTypes, loading, policyTypeCode, policyPlanIds, cellCaptiveName, intl } = this.props;
    const { selectedBenefits } = this.props.form;
    const visitingNewZealandPolicyTypes = ['VISIT-NZ', 'VISIT-NZ-WLP001'];
    const isVisitingNewZealand = visitingNewZealandPolicyTypes.includes(policyTypeCode);
    const domesticPolicyTypes = ['DOM-AU', 'DOM-NZ'];
    const isDomestic = domesticPolicyTypes.includes(policyTypeCode);
    const list =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];
    const check = (d) =>
      list.filter((m) => d.codeList.indexOf(m.claimCode) > -1).length > 0;
    let claimTypeList =
      !!claimTypes && typeof claimTypes.toJS === 'function'
        ? claimTypes.toJS()
        : claimTypes;

    if (isVisitingNewZealand) {
      claimTypeList = claimTypeList.filter((x) => x.description !== 'Baggage and personal items');
    } else {
      claimTypeList = claimTypeList.filter((x) => x.description !== 'Cash, bank cards, travel documents and passports');
    }

    if (isDomestic) {
      claimTypeList = claimTypeList.filter((x) => x.description !== 'Medical and evacuation');
    }

    const normalizedPolicyPlanIds = Array.isArray(policyPlanIds)
      ? policyPlanIds
      : (policyPlanIds && typeof policyPlanIds.toJS === 'function'
        ? policyPlanIds.toJS()
        : []);

    const hasAnyTugoPlanId = normalizedPolicyPlanIds.some((planId) =>
      LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_TUGO_BENEFIT_TILES.includes(planId)
    ) || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_TUGO_BENEFIT_TILES.includes(policyTypeCode);

    if (hasAnyTugoPlanId) {
      const hasMedicalBenefitsPlan =
        normalizedPolicyPlanIds.some((planId) =>
          LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_MEDICAL_BENEFITS.includes(planId) ||
          LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(planId)
        ) ||
        LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_MEDICAL_BENEFITS.includes(policyTypeCode) ||
        LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(policyTypeCode);
      const hasTripCancellationPlan =
        normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_CANCELLATION.includes(planId))
        || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_CANCELLATION.includes(policyTypeCode);
      const hasTripInterruptionPlan =
        normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_INTERRUPTION.includes(planId))
        || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_TRIP_INTERRUPTION.includes(policyTypeCode);
      const hasADAndDPlan =
        normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_AD_AND_D.includes(planId))
        || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_AD_AND_D.includes(policyTypeCode);

      if (!hasMedicalBenefitsPlan) {
        claimTypeList = claimTypeList.filter((x) =>
          x.description !== 'Medical Benefits' &&
          x.description !== 'Medical Expenses' &&
          x.description !== 'Medical Expenses - Visitors to Canada' &&
          x.description !== 'Student Medical Benefits'
        );
      }
      if (!hasTripCancellationPlan) {
        claimTypeList = claimTypeList.filter((x) => x.description !== 'Changes to your journey');
      }
      if (!hasTripInterruptionPlan) {
        claimTypeList = claimTypeList.filter((x) => x.description !== 'Trip Interruption');
      }
      if (!hasADAndDPlan) {
        claimTypeList = claimTypeList.filter((x) => x.description !== 'AD&D');
      }
    }

    const lists = claimTypeList.filter((d) => !listCodeForDuesProtect.includes(d.claimCode));

    lists.sort((a, b) => {
      const indexA = listNameBenefitForTripCan.indexOf(a.description);
      const indexB = listNameBenefitForTripCan.indexOf(b.description);
      if (a.description === 'Other') return 1;
      if (b.description === 'Other') return -1;
      return indexA - indexB;
    });
    const isScti = appConfig.reactAppEnv === 'scti';
    const isShowTooltip = isScti; // currently hide tooltip for SCTI
    const isVisitorsToCanada = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_VISITORS_TO_CANADA;
    const isInboundStudent = LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_STUDENT.includes(policyTypeCode);
    const listsWithTooltips = lists.map((item) => {
      const itemWithTooltip = { ...item };
      switch (item.description) {
        case 'Medical Expense':
          itemWithTooltip.addTooltip = 'Medical expenses (hospital costs, x-rays, doctor visits etc.) incurred as a result of injury or illness whilst on your trip';
          break;
        case 'Changes to your journey':
          itemWithTooltip.addTooltip = 'Costs incurred because you had to cancel your trip, or due to a trip interruption, delay or missed connection';
          break;
        case 'Baggage and Personal Items':
          itemWithTooltip.addTooltip = 'Reimbursement for lost, stolen or damaged property; or costs associated with delay of your baggage in transit';
          break;
        case 'Other':
          itemWithTooltip.addTooltip = intl.formatMessage({ id: 'fastCover.stepWhatHappened.costsOfRepatriationOrReimbursement' });
          itemWithTooltip.addTooltipVisitorsToCanada = intl.formatMessage({ id: 'fastCover.stepWhatHappened.expensesRelatedToDeath' });
          itemWithTooltip.addTooltipInboundStudent = intl.formatMessage({ id: 'fastCover.stepWhatHappened.expensesRelatedToDeathOrDismemberment' });
          itemWithTooltip.isShowTooltip = isVisitorsToCanada;
          itemWithTooltip.isShowTooltipInboundStudent = isInboundStudent;
          break;
        case 'Collision Damage':
          itemWithTooltip.addTooltip = 'Costs related to your rental vehicle being damaged or stolen';
          break;
        default:
          itemWithTooltip.addTooltip = null;
          break;
      }
      return itemWithTooltip;
    });
    return (
      <div className={'row'} style={{ padding: '5px' }}>
        {!!listsWithTooltips &&
          listsWithTooltips.length > 0 &&
          orderBy(listsWithTooltips, ['order'], ['asc']).map((d) => (
            <div className={'col-sm-6'} key={d.claimTypeId}>
              <label
                className={`checkbox-container ${check(d) ? 'checked' : 'unchecked'} ${isReadOnly || loading ? 'disabled' : ''}`}
              >
                <div>
                  <div
                    className={
                      'd-flex flex-row justify-content-center align-items-center'
                    }
                  >
                    <div>{this.renderBenefitImage(d.claimCode)}</div>
                    <div
                      className={'d-inline font-weight-bold benefit-description-text'}
                    >
                      {formatBenefitDescription(intl, d.description)} {(isShowTooltip || d.isShowTooltip || d.isShowTooltipInboundStudent) && <FNOLTooltip dataFor={'addTooltip'} content={d.isShowTooltipInboundStudent ? d.addTooltipInboundStudent : (d.isShowTooltip ? d.addTooltipVisitorsToCanada : d.addTooltip)} />}
                    </div>
                  </div>
                </div>
                <div className="d-flex">
                  <input
                    disabled={isReadOnly || loading}
                    value={d.claimTypeId}
                    onChange={this.onChangeBenefit.bind(this, d)}
                    type="checkbox"
                    checked={check(d)}
                  />
                  <span className="checkmark"></span>
                </div>
              </label>
            </div>
          ))}
      </div>
    );
  };
  renderBenefitForDuesProtect = (isReadOnly) => {
    const { claimTypes, loading, intl } = this.props;
    const { selectedBenefits } = this.props.form;
    const list =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];
    const check = (d) =>
      list.filter((m) => d.codeList.indexOf(m.claimCode) > -1).length > 0;
    const claimTypeList =
      !!claimTypes && typeof claimTypes.toJS === 'function'
        ? claimTypes.toJS()
        : claimTypes;

    const isDisabled = isReadOnly || loading;
    const checkDisable = (d) => {
      if (list.length === 0) {
        return false;
      }
      const result = list.filter((m) => m.claimCode === d.claimCode).length > 0;
      return !result;
    };
    const lists = claimTypeList.filter((d) => listCodeForDuesProtect.includes(d.claimCode));
    return (
      <div className={'row'} style={{ padding: '5px' }}>
        {!!lists &&
          lists.length > 0 &&
          orderBy(lists, ['position'], ['asc']).map((d) => (
            <div className={'col-sm-6'} key={d.claimTypeId}>
              <label
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  border: check(d) ? '2px solid #44b4a6' : '1px solid #e6e6e6',
                  padding: '15px',
                  backgroundColor: '#f0f4f7',
                  cursor: isReadOnly || loading ? 'not-allowed' : 'pointer',
                }}
                className={'checkbox-container'}
              >
                <div>
                  <div
                    className={
                      'd-flex flex-row justify-content-center align-items-center'
                    }
                  >
                    <div>{this.renderBenefitImage(d.claimCode)}</div>
                    <div
                      className={'d-inline font-weight-bold benefit-description-text'}
                    >
                      {formatBenefitDescription(intl, d.description)}
                    </div>
                  </div>
                </div>
                <div className="d-flex">
                  <input
                    disabled={isDisabled || checkDisable(d)}
                    value={d.claimTypeId}
                    onChange={this.onChangeBenefit.bind(this, d)}
                    type="checkbox"
                    checked={check(d)}
                  />
                  <span
                    style={{
                      border: checkDisable(d) ? '3px solid #e6e6e6' : '3px solid #44b4a6',
                    }}
                    className="checkmark"
                  ></span>
                </div>
              </label>
            </div>
          ))}
      </div>
    );
  };

  renderTourOperator() {
    const {
      nameOfTheTourOperator,
      address,
      cityOrTown,
      countryTourOperator,
      postalCode,
      contact,
      phoneNumber,
      bookingReservationNumber,
      destinations,
      cityOfDeparture,
      returnDestination,
      dateOfInitialPaymentDesposit,
      ifNotIncludedInThePackage,
    } = this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <div className={'row'}>
          <div className={'col-sm-6 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.nameOfTheTourOperator} />
            </PageSectionHeader>
          </div>
          <div className={'col-sm-6 form-group'}>
            <Textbox
              name="nameOfTheTourOperator"
              type="text"
              onChange={this.handleChange('form.nameOfTheTourOperator')}
              value={nameOfTheTourOperator}
              disabled={isReadOnly}
            />
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.address} />
            </PageSectionHeader>
            <Textbox
              name="address"
              type="text"
              onChange={this.handleChange('form.address')}
              value={address}
              disabled={isReadOnly}
            />
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.cityOrTown} />
            </PageSectionHeader>
            <Textbox
              name="cityOrTown"
              type="text"
              onChange={this.handleChange('form.cityOrTown')}
              value={cityOrTown}
              disabled={isReadOnly}
            />
          </div>
          <div className={'col-sm-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.country} />
            </PageSectionHeader>
            <Textbox
              name="country"
              type="text"
              onChange={this.handleChange('form.countryTourOperator')}
              value={countryTourOperator}
              disabled={isReadOnly}
            />
          </div>
          <div className={'col-sm-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.postalCode} />
            </PageSectionHeader>
            <Textbox
              name="postalCode"
              type="text"
              onChange={this.handleChange('form.postalCode')}
              value={postalCode}
              disabled={isReadOnly}
            />
          </div>
        </div>
        <div className={'ml-2 row'}>
          <div className={'col-sm-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.contact} />
            </PageSectionHeader>
            <Textbox
              name="contact"
              type="text"
              onChange={this.handleChange('form.contact')}
              value={contact}
              disabled={isReadOnly}
            />
          </div>
          <div className={'col-sm-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.phoneNumber} />
            </PageSectionHeader>
            <Textbox
              name="phoneNumber"
              type="text"
              onChange={this.handleChangePhoneNumber('form.phoneNumber')}
              value={phoneNumber}
              disabled={isReadOnly}
            />
          </div>
          <div className={'col-sm-4 form-group'}>
          </div>
        </div>
        <div>
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.bookingReservationNumber} />
              </PageSectionHeader>
              <Textbox
                name="bookingReservationNumber"
                type="text"
                onChange={this.handleChange('form.bookingReservationNumber')}
                value={bookingReservationNumber}
                disabled={isReadOnly}
              />
            </div>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.destinations} />
              </PageSectionHeader>
              <Textbox
                name="destinations"
                type="text"
                onChange={this.handleChange('form.destinations')}
                value={destinations}
                disabled={isReadOnly}
              />
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.cityOfDeparture} />
              </PageSectionHeader>
              <Textbox
                name="country"
                type="text"
                onChange={this.handleChange('form.cityOfDeparture')}
                value={cityOfDeparture}
                disabled={isReadOnly}
              />
            </div>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.returnDestination} />
              </PageSectionHeader>
              <Textbox
                name="returnDestination"
                type="text"
                onChange={this.handleChange('form.returnDestination')}
                value={returnDestination}
                disabled={isReadOnly}
              />
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.dateOfInitialPaymentDesposit} />
              </PageSectionHeader>
              <DatePicker
                disabled={isReadOnly}
                type="text"
                onDayChange={this.handleDayChange('form.dateOfInitialPaymentDesposit')}
                value={dateOfInitialPaymentDesposit}
                placeholder="dd/mm/yyyy"
              />
            </div>
            <div className={'col-sm-6 form-group'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.ifNotIncludedInThePackage} />
              </PageSectionHeader>
              <TextArea
                disabled={isReadOnly}
                name="storyEvent"
                type="text"
                onChange={this.handleChange('form.ifNotIncludedInThePackage')}
                value={ifNotIncludedInThePackage}
                isSummary={isSummary}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPurposeOfTrip() {
    const {
      purposeOfTrip,
    } = this.props.form;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <Validate
              name="paymentVia"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={purposeOfTrip}
              fieldName={messages.purposeOfTrip}
            >
              <FlexBox>
                <OptionsContainer style={{ margin: '0px 40px 0px 35px' }}>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Holiday"
                    checked={purposeOfTrip === 'Holiday'}
                    onChange={this.handleChange('form.purposeOfTrip')}
                  />
                  <FormattedMessage {...messages.holiday} />
                </OptionsContainer>
                <OptionsContainer style={{ margin: '0px 40px 0px 35px' }}>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Business"
                    checked={purposeOfTrip === 'Business'}
                    onChange={this.handleChange('form.purposeOfTrip')}
                  />
                  <FormattedMessage {...messages.business} />
                </OptionsContainer>
                <OptionsContainer style={{ margin: '0px 40px 0px 35px' }}>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Medical"
                    checked={purposeOfTrip === 'Medical'}
                    onChange={this.handleChange('form.purposeOfTrip')}
                  />
                  <FormattedMessage {...messages.medical} />
                </OptionsContainer>
                <OptionsContainer style={{ margin: '0px 40px 0px 35px' }}>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Study"
                    checked={purposeOfTrip === 'Study'}
                    onChange={this.handleChange('form.purposeOfTrip')}
                  />
                  <FormattedMessage {...messages.study} />
                </OptionsContainer>
                <OptionsContainer style={{ margin: '0px 40px 0px 35px' }}>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="Other"
                    checked={purposeOfTrip === 'Other'}
                    onChange={this.handleChange('form.purposeOfTrip')}
                  />
                  <FormattedMessage {...messages.other} />
                </OptionsContainer>
              </FlexBox>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.purposeOfTrip}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      </div>
    );
  }

  renderTripDates = (isReadOnly, dateBookedTrip, dateScheduledToDepart, dateOriginallyScheduled) => {
    return (
      <div className={'row'}>
        <div
          className={'col-sm-6 col-md-4 form-group'}
          style={{
            flexGrow: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <PageSectionHeader>
            <FormattedMessage {...messages.dateBookedTrip} />
          </PageSectionHeader>
          <DatePicker
            position={'bottom-start'}
            name="dateBookedTrip"
            type="text"
            onDayChange={this.handleDayChange('form.dateBookedTrip')}
            value={dateBookedTrip}
            placeholder=""
            disabled={isReadOnly}
          />
        </div>
        <div className={'col-sm-6 col-md-4 form-group'}>
          <PageSectionHeader>
            <FormattedMessage {...messages.dateScheduledToDepart} />
          </PageSectionHeader>
          <DatePicker
            position={'bottom-start'}
            disabled={isReadOnly}
            name="dateScheduledToDepart"
            type="text"
            onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
            value={dateScheduledToDepart}
            placeholder=""
          />
        </div>
        <div className={'col-sm-6 col-md-4 form-group'}>
          <PageSectionHeader>
            <FormattedMessage {...messages.dateOriginallyScheduled} />
          </PageSectionHeader>
          <DatePicker
            position={'bottom-start'}
            disabled={isReadOnly}
            name="dateOriginallyScheduled"
            type="text"
            onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
            value={dateOriginallyScheduled}
            placeholder=""
          />
        </div>
      </div>
    );
  };

  renderPolicyDates = (policyPurchaseDate, policyEffectiveDate, policyTerminationDate) => {
    return (
      <div className={'row'}>
        <div
          className={'col-sm-6 col-md-4 form-group'}
          style={{
            flexGrow: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <PageSectionHeader>
            <FormattedMessage {...messages.policyPurchaseDate} />
          </PageSectionHeader>
          <DatePicker
            position={'bottom-start'}
            name="dateBookedTrip"
            type="text"
            onDayChange={this.handleDayChange('form.dateBookedTrip')}
            value={policyPurchaseDate}
            placeholder=""
            disabled
          />
        </div>
        <div className={'col-sm-6 col-md-4 form-group'}>
          <PageSectionHeader>
            <FormattedMessage {...messages.policyEffectiveDate} />
          </PageSectionHeader>
          <DatePicker
            position={'bottom-start'}
            disabled
            name="dateScheduledToDepart"
            type="text"
            onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
            value={policyEffectiveDate}
            placeholder=""
          />
        </div>
        <div className={'col-sm-6 col-md-4 form-group'}>
          <PageSectionHeader>
            <FormattedMessage {...messages.policyTerminationDate} />
          </PageSectionHeader>
          <DatePicker
            position={'bottom-start'}
            disabled
            name="dateOriginallyScheduled"
            type="text"
            onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
            value={policyTerminationDate}
            placeholder=""
          />
        </div>
      </div>
    );
  };

  renderEventDateField = (isReadOnly, dateOfEvent, fnolReportDateValidationStatus, checkDate, intl) => {
    const commonProps = {
      name: 'dateOfEvent',
      validators: fnolReportDateValidationStatus ? [required, checkDate] : [required],
      group: this.validatorGroup,
      addValidatorToGroup: this.validatorGroup.addValidatorToGroup,
      validChangeInGroup: this.validatorGroup.validChangeInGroup,
      validationCounter: this.state.validationCounter,
      timeValidateCounter: this.state.timeValidateCounter,
      validatorLeaveGroup: this.validatorGroup.removeValidatorToGroup,
      defaultValue: dateOfEvent,
      fieldName: messages.dateOfEvent,
      tooltipDataFor: 'dateOfEventHint',
      tooltipContent: intl.formatMessage({ id: 'fastCover.stepWhatHappened.dateOfEventTooltipContent' }),
      tooltipPlace: 'bottom',
    };

    return (
      <div className={'form-group col-sm-6'}>
        <Validate {...commonProps}>
          <DatePicker
            position={'bottom-start'}
            disabled={isReadOnly}
            name="dateOfEvent"
            type="text"
            onDayChange={this.handleDayChange('form.dateOfEvent')}
            value={dateOfEvent}
            placeholder=""
          />
          <ErrorMessage for="required">
            <FormattedMessage
              {...messages.isRequired}
              values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.dateOfEvent' }) }}
            />
          </ErrorMessage>
          {fnolReportDateValidationStatus && (
            <ErrorMessage for={checkDate}>
              <FormattedMessage
                {...messages.checkEventDate}
                values={messages.dateOfEvent}
              />
            </ErrorMessage>
          )}
        </Validate>
      </div>
    );
  };

  renderEventTimeField = (isReadOnly, newTimeOfEvent, fnolReportDateValidationStatus, checkTime, intl) => {
    const commonProps = {
      name: 'timeOfEvent',
      validators: fnolReportDateValidationStatus ? [required, checkTime] : [required],
      group: this.validatorGroup,
      addValidatorToGroup: this.validatorGroup.addValidatorToGroup,
      validChangeInGroup: this.validatorGroup.validChangeInGroup,
      validationCounter: this.state.validationCounter,
      validatorLeaveGroup: this.validatorGroup.removeValidatorToGroup,
      defaultValue: newTimeOfEvent,
      fieldName: messages.timeOfEvent,
      tooltipContent: intl.formatMessage({ id: 'fastCover.stepWhatHappened.timeOfEventTooltipContent' }),
      tooltipDataFor: 'timeOfEventHint',
      tooltipPlace: fnolReportDateValidationStatus ? 'bottom' : undefined,
    };

    return (
      <div className={'form-group col-sm-6'}>
        <Validate {...commonProps}>
          <TimePickerInput
            cb={this.checkTimeCallBack}
            allowEmpty
            showSecond={false}
            onChange={this.onChange('form.timeOfEvent')}
            value={newTimeOfEvent}
            disabled={isReadOnly}
          />
          <ErrorMessage for="required">
            <FormattedMessage
              {...messages.isRequired}
              values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.timeOfEvent' }) }}
            />
          </ErrorMessage>
          {fnolReportDateValidationStatus && (
            <ErrorMessage for={checkTime}>
              <FormattedMessage
                {...messages.checkEventTime}
                values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.timeOfEvent' }) }}
              />
            </ErrorMessage>
          )}
        </Validate>
      </div>
    );
  };

  renderTripDatesSection = (
    showZurichUHC,
    isClaimForFieldEnabled,
    showTrawickFNOLRefactoring,
    isReadOnly,
    dateBookedTrip,
    dateScheduledToDepart,
    dateOriginallyScheduled,
    policyPurchaseDate,
    policyEffectiveDate,
    policyTerminationDate,
  ) => {
    if (!showZurichUHC && !isClaimForFieldEnabled && !showTrawickFNOLRefactoring) {
      return (
        <div className={'row'}>
          <div
            className={'col-sm-6 col-md-4 form-group'}
            style={{
              flexGrow: 0,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <PageSectionHeader>
              <FormattedMessage {...messages.dateBookedTrip} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              name="dateBookedTrip"
              type="text"
              onDayChange={this.handleDayChange('form.dateBookedTrip')}
              value={dateBookedTrip}
              placeholder=""
              disabled={isReadOnly}
            />
          </div>
          <div className={'col-sm-6 col-md-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.dateScheduledToDepart} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled={isReadOnly}
              name="dateScheduledToDepart"
              type="text"
              onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
              value={dateScheduledToDepart}
              placeholder=""
            />
          </div>
          <div className={'col-sm-6 col-md-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.dateOriginallyScheduled} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled={isReadOnly}
              name="dateOriginallyScheduled"
              type="text"
              onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
              value={dateOriginallyScheduled}
              placeholder=""
            />
          </div>
        </div>
      );
    }

    if (showZurichUHC) {
      return (
        <div className={'row'}>
          <div
            className={'col-sm-6 col-md-4 form-group'}
            style={{
              flexGrow: 0,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <PageSectionHeader>
              <FormattedMessage {...messages.policyPurchaseDate} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              name="dateBookedTrip"
              type="text"
              onDayChange={this.handleDayChange('form.dateBookedTrip')}
              value={policyPurchaseDate}
              placeholder=""
              disabled
            />
          </div>
          <div className={'col-sm-6 col-md-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.policyEffectiveDate} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled
              name="dateScheduledToDepart"
              type="text"
              onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
              value={policyEffectiveDate}
              placeholder=""
            />
          </div>
          <div className={'col-sm-6 col-md-4 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.policyTerminationDate} />
            </PageSectionHeader>
            <DatePicker
              position={'bottom-start'}
              disabled
              name="dateOriginallyScheduled"
              type="text"
              onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
              value={policyTerminationDate}
              placeholder=""
            />
          </div>
        </div>
      );
    }

    if (!showZurichUHC && isClaimForFieldEnabled) {
      const { intl } = this.props;
      return (
        <div className={'row'}>
          <div className={'form-group col-sm-6'}>
            <Validate
              name="dateScheduledToDepart"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={dateScheduledToDepart}
              fieldName={messages.dateScheduledToDepart}
            >
              <DatePicker
                position={'bottom-start'}
                disabled={isReadOnly}
                name="dateScheduledToDepart"
                type="text"
                onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
                value={dateScheduledToDepart}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.dateScheduledToDepart' }) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className={'form-group col-sm-6'}>
            <Validate
              name="dateOriginallyScheduled"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={dateOriginallyScheduled}
              fieldName={messages.dateOriginallyScheduled}
            >
              <DatePicker
                position={'bottom-start'}
                disabled={isReadOnly}
                name="dateOriginallyScheduled"
                type="text"
                onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
                value={dateOriginallyScheduled}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.dateOriginallyScheduled' }) }}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
      );
    }

    return null;
  };

  renderLocationFields = (
    isReadOnly,
    newVersionCountry,
    country,
    selectedCountry,
    city,
    countries,
    countryList,
    countryTooltipContent,
    intl,
  ) => {
    const getCountryValue = () => {
      if (!selectedCountry) return null;
      return typeof selectedCountry.toJS === 'function' ? selectedCountry.toJS() : selectedCountry;
    };

    const getCityValue = () => {
      if (!city) return null;
      return typeof city.toJS === 'function' ? city.toJS() : city;
    };

    return (
      <div className={'row'}>
        {newVersionCountry ? (
          <div className={'form-group col-sm-6'}>
            <Validate
              name="country"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={country}
              fieldName={messages.country}
              tooltipContent={countryTooltipContent}
              tooltipDataFor={'countryHint'}
              tooltipPlace={'right'}
            >
              <AsyncCreatable
                loadOptions={this.loadCountry}
                name="country"
                className="react-select-container"
                classNamePrefix="react-select"
                styles={{
                  input: (styles) => ({ ...styles, border: 'none !important' }),
                }}
                value={getCountryValue()}
                placeholder={intl.formatMessage({ id: 'fastCover.stepWhatHappened.typeACountry' })}
                isClearable
                isDisabled={isReadOnly}
                onChange={(e) => this.handleChangeCountry(e)}
                defaultOptions={countries}
              />
              <ErrorMessage for="required">
                <FormattedMessage {...messages.isRequired} values={messages.country} />
              </ErrorMessage>
            </Validate>
          </div>
        ) : (
          <div className={'form-group col-sm-6'}>
            <Validate
              name="country"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={country}
              fieldName={messages.country}
              tooltipContent={countryTooltipContent}
              tooltipDataFor={'countryHint'}
              tooltipPlace={'right'}
            >
              <MySelect
                dataList={countryList}
                disabled={isReadOnly}
                onChange={(v) => this.handleChangeCountry(v)}
                value={country}
              />
              <ErrorMessage for="required">
                <FormattedMessage {...messages.isRequired} values={messages.country} />
              </ErrorMessage>
            </Validate>
          </div>
        )}

        <div className={'form-group col-sm-6'}>
          <Validate
            name="city"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={city}
            fieldName={messages.city}
            tooltipContent={intl.formatMessage({ id: 'fastCover.stepWhatHappened.cityTooltipContent' })}
            tooltipDataFor={'cityHint'}
            tooltipPlace={'right'}
          >
            <AsyncCreatable
              key={this.getCitySelectKey(selectedCountry)}
              loadOptions={this.loadCity}
              name="city"
              className="react-select-container"
              classNamePrefix="react-select"
              styles={{
                input: (styles) => ({ ...styles, border: 'none !important' }),
              }}
              value={getCityValue()}
              placeholder={intl.formatMessage({ id: 'fastCover.stepWhatHappened.typeACity' })}
              isClearable
              isDisabled={!selectedCountry || isReadOnly}
              onChange={(e) => this.props.onFormDataChange('form.city', e)}
              defaultOptions
              noOptionsMessage={this.cityNoOptionsMessage}
            />
            <ErrorMessage for="required">
              <FormattedMessage
                {...messages.isRequired}
                values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.city' }) }}
              />
            </ErrorMessage>
          </Validate>
        </div>
      </div>
    );
  };

  renderClaimForSection = (
    isReadOnly,
    newVersion,
    isClaimForFieldEnabled,
    isClaimGroupAllowed,
    insuredsList,
    selectedClaimForList,
    isMultipleClaimFor,
    usePrimaryMemberEmailAddressForAllMember,
    usePrimaryMemberPhoneNumberForAllMember,
    intl,
  ) => {
    if (insuredsList.length > 1 && isClaimGroupAllowed) {
      return (
        <div>
          <div className={'row mt-3'}>
            <div className={'col-sm-12'}>
              <HelpText>
                A claim will be created for the claimant, if you select additional member, a claim will be created for the member added.
              </HelpText>
            </div>
            <div className={'col-sm-12'}>
              <HelpText>
                Note also: The primary claimant payment details will be used for all members you select for this claim. If you need any member to be paid to a different bank account, please go back to the Claim List screen and create a separate claim for this member.
              </HelpText>
            </div>
          </div>

          {newVersion && insuredsList.length > 1 && !isClaimForFieldEnabled && (
            <div className={'row mt-3'}>
              <div className={'form-group col-sm-6'}>
                <Validate
                  name="claimFor"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={selectedClaimForList}
                  fieldName={messages.claimFor}
                  tooltipContent={intl.formatMessage({ id: 'fastCover.stepWhatHappened.claimForTooltip' })}
                  tooltipDataFor={'claimForHint'}
                  tooltipPlace={'right'}
                >
                  <Select
                    name="claimFor"
                    isMulti
                    isDisabled={isReadOnly}
                    options={insuredsList}
                    placeholder="Select Insured(s)"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    onChange={(v) => this.handleChangeInsureds(v)}
                    value={selectedClaimForList}
                    getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                    getOptionValue={(option) => option.id}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.insureds' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          )}

          {isMultipleClaimFor && !isClaimForFieldEnabled && (
            <div className={'ml-3'}>
              <div className={'row'}>
                <div className={'form-group col-md-6'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="usePrimaryMemberEmailAddressForAllMember"
                      checked={usePrimaryMemberEmailAddressForAllMember === true}
                      onChange={this.handleChange('form.usePrimaryMemberEmailAddressForAllMember')}
                    />
                    <span>
                      <FormattedMessage {...messages.usePrimaryMemberEmailAddressForAllMember} />
                    </span>
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="usePrimaryMemberPhoneNumberForAllMember"
                      checked={usePrimaryMemberPhoneNumberForAllMember === true}
                      onChange={this.handleChange('form.usePrimaryMemberPhoneNumberForAllMember')}
                    />
                    <span>
                      <FormattedMessage {...messages.usePrimaryMemberPhoneNumberForAllMember} />
                    </span>
                  </OptionsContainer>
                </div>
                <div className={'form-group col-md-6'} />
              </div>
              {newVersion && this.renderInforInsured()}
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  renderStoryField = (
    isReadOnly,
    isSummary,
    showTrawickFNOLRefactoring,
    isClaimForFieldEnabled,
    storyEvent,
    intl,
  ) => {
    if (showTrawickFNOLRefactoring) {
      return (
        <div className={'form-group col'}>
          <Validate
            name="tellUsWhatHappened"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={storyEvent}
            fieldName={messages.pleaseDescribeWhatIsBeingClaimedOrWhatHappenedInDetail}
            tooltipContent={messages.tellUsWhatHappenedTooltip.defaultMessage}
            tooltipDataFor={'tellUsWhatHappenedHint'}
          >
            <TextArea
              disabled={isReadOnly}
              name="storyEvent"
              type="text"
              onChange={this.handleChange('form.storyEvent')}
              value={storyEvent}
              isSummary={isSummary}
            />
            <ErrorMessage for="required">
              <FormattedMessage
                {...messages.isRequired}
                values={messages.pleaseDescribeWhatIsBeingClaimedOrWhatHappenedInDetail}
              />
            </ErrorMessage>
          </Validate>
        </div>
      );
    }

    return (
      <div className={'form-group col'}>
        <Validate
          name="storyEvent"
          validators={[required]}
          group={this.validatorGroup}
          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
          validChangeInGroup={this.validatorGroup.validChangeInGroup}
          validationCounter={this.state.validationCounter}
          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
          defaultValue={storyEvent}
          fieldName={!isClaimForFieldEnabled ? messages.storyEvent : messages.storyEventSCTI}
        >
          <TextArea
            disabled={isReadOnly}
            name="storyEvent"
            type="text"
            onChange={this.handleChange('form.storyEvent')}
            value={storyEvent}
            isSummary={isSummary}
          />
          <ErrorMessage for="required">
            <FormattedMessage
              {...messages.isRequired}
              values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.storyEvent' }) }}
            />
          </ErrorMessage>
        </Validate>
      </div>
    );
  };

  renderDuesProtectFields = (isReadOnly, whatIsTheOutstandingDuesAmount, currency, intl) => {
    return (
      <div className={'row'}>
        <div className={'col-sm-6 form-group'}>
          <Validate
            name="whatIsTheOutstandingDuesAmount"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={whatIsTheOutstandingDuesAmount}
            fieldName={messages.whatIsTheOutstandingDuesAmount}
          >
            <Textbox
              name="whatIsTheOutstandingDuesAmount"
              type="number"
              onChange={this.handleChange('form.whatIsTheOutstandingDuesAmount')}
              value={whatIsTheOutstandingDuesAmount}
              disabled={isReadOnly}
            />
            <ErrorMessage for="required">
              <FormattedMessage
                {...messages.isRequired}
                values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.whatIsTheOutstandingDuesAmount' }) }}
              />
            </ErrorMessage>
          </Validate>
        </div>
        <div className={'col-sm-6 form-group'}>
          <Validate
            name="currency"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={currency}
            fieldName={messages.currency}
          >
            <CurrencySelector
              onChange={this.handleCurrencyChange('form.currency')}
              disabled={isReadOnly}
              value={currency}
            />
            <ErrorMessage for="required">
              <FormattedMessage {...messages.isRequired} values={messages.currency} />
            </ErrorMessage>
          </Validate>
        </div>
      </div>
    );
  };

  renderInforInsured() {
    const { form, submitted, isSummary } = this.props;
    const { usePrimaryMemberEmailAddressForAllMember, selectedClaimFor, usePrimaryMemberPhoneNumberForAllMember } = isSummary ? this.summaryFormValue() : form;
    const selectedClaimForList = selectedClaimFor ? selectedClaimFor.toJS ? selectedClaimFor.toJS() : selectedClaimFor : [];
    const isReadOnly = submitted || isSummary;
    const isReadOnlyEmail = isReadOnly || usePrimaryMemberEmailAddressForAllMember;
    const isReadOnlyPhoneNumber = isReadOnly || usePrimaryMemberPhoneNumberForAllMember;

    const handleChangeEmail = (insuredId, evt) => {
      const updatedSelectedClaimForList = selectedClaimForList.map((insured) => {
        if (insured.id === insuredId) {
          return {
            ...insured,
            email: evt.target.value,
          };
        }
        return insured;
      });
      this.props.onFormDataChange('form.selectedClaimFor', updatedSelectedClaimForList);
      this.props.setFormHasChanges(true);
    };

    const handleChangePhoneNumber = (insuredId, evt) => {
      const updatedSelectedClaimForList = selectedClaimForList.map((insured) => {
        if (insured.id === insuredId) {
          return {
            ...insured,
            phoneNumber: evt.target.value,
          };
        }
        return insured;
      });
      this.props.onFormDataChange('form.selectedClaimFor', updatedSelectedClaimForList);
      this.props.setFormHasChanges(true);
    };

    return (
      <div>
        <div className="row">
          <div className="col-sm-2 form-group">
            <PageSectionHeader>
              <FormattedMessage {...messages.name} />
            </PageSectionHeader>
          </div>
          <div className="col-sm-5 form-group">
            <PageSectionHeader>
              <FormattedMessage {...messages.email} />
            </PageSectionHeader>
          </div>
          <div className="col-sm-5 form-group">
            <PageSectionHeader>
              <FormattedMessage {...messages.phoneNumber} />
            </PageSectionHeader>
          </div>
        </div>
        {selectedClaimForList.map((insured, index) => (
          <div className="row" key={index}>
            <div className="col-sm-2 form-group">
              <Textbox
                name="name"
                type="text"
                value={insured.firstname}
                disabled
              />
            </div>
            <div className={'col-sm-5 form-group'}>
              <Validate
                name="thirdPartyRelationShip"
                validators={[required, validEmail]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={insured.email}
              >
                <Textbox
                  name="email"
                  type="text"
                  disabled={isReadOnlyEmail}
                  onChange={(evt) => handleChangeEmail(insured.id, evt)}
                  value={insured.email}
                />
                <ErrorMessage for="validEmail">
                  <FormattedMessage
                    {...messages.isValid}
                    values={messages.email}
                  />
                </ErrorMessage>
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.email}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'col-sm-5 form-group'}>
              <Validate
                name="thirdPartyRelationShip"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={insured.phoneNumber}
              >
                <Textbox
                  name="phoneNumber"
                  type="number"
                  disabled={isReadOnlyPhoneNumber}
                  onChange={(evt) => handleChangePhoneNumber(insured.id, evt)}
                  value={insured.phoneNumber}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.phoneNumber}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const countryTooltipContent = 'Country where the incident occurred.';

    const {
      isSummary,
      submitted,
      loading,
      countryList,
      provinceList,
      fnolReportDateValidationStatus,
      jsonVersion,
      insuredsList,
      claimTypes,
      isClaimGroupAllowed,
      showZurichUHC,
      policyPurchaseDate,
      policyEffectiveDate,
      policyTerminationDate,
      isClaimForFieldEnabled,
      showTrawickFNOLRefactoring,
      intl,
      eventDescriptionLimit,
      cellCaptiveName,
      policyTypeCode,
      policyPlanIds,
    } = this.props;

    const {
      dateOfEvent,
      dateSymptomsStarted,
      timeOfEvent,
      country,
      city,
      province,
      storyEvent,
      selectedBenefits,
      dateBookedTrip,
      dateScheduledToDepart,
      dateOriginallyScheduled,
      selectedClaimFor,
      whatIsTheOutstandingDuesAmount,
      currency,
      selectedCountry,
      usePrimaryMemberEmailAddressForAllMember,
      usePrimaryMemberPhoneNumberForAllMember,
    } = isSummary ? this.summaryFormValue() : this.props.form;

    const countries = countryList && typeof countryList.toJS === 'function'
      ? countryList.toJS()
      : countryList || [];
    const provinces = provinceList && typeof provinceList.toJS === 'function'
      ? provinceList.toJS()
      : provinceList || [];
    const localizedProvinces = provinces.map((provinceOption) => formatProvinceOption(intl, provinceOption));
    const isReadOnly = submitted || isSummary;

    let canMoveNext = !!dateOfEvent && !!timeOfEvent;

    const claimTypeList =
      !!claimTypes && typeof claimTypes.toJS === 'function'
        ? claimTypes.toJS()
        : claimTypes;

    const isVisibleDuesProtect = (claimTypeList.filter((d) => ((listCodeForDuesProtect).filter((c) => c === d.claimCode)).length > 0)).length > 0;
    if (isVisibleDuesProtect === true) {
      canMoveNext = true;
    }

    const newTimeOfEvent = timeOfEvent ? moment(timeOfEvent) : null;

    const checkDate = checkEventDate(timeOfEvent);
    const checkTime = checkEventTime(dateOfEvent);

    const newVersion = jsonVersion > 7;
    const newVersionCountry = jsonVersion > 9;

    const list =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];

    const selectedClaimForList = !!selectedClaimFor && typeof selectedClaimFor.toJS === 'function'
      ? selectedClaimFor.toJS()
      : selectedClaimFor || [];

    if (newVersion && selectedClaimForList.length < 1 && insuredsList.length === 1) {
      this.handleChangeInsureds([insuredsList[0]]);
    }

    const isMultipleClaimFor = insuredsList.length > 1 && selectedClaimForList.length > 0 && isClaimGroupAllowed;
    const isLimitEventDescLength = eventDescriptionLimit && eventDescriptionLimit > 0;
    const isScti = appConfig.reactAppEnv === 'scti';
    const isTugo = appConfig.reactAppEnv === 'tugo';
    const isVisitorsToCanada = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_VISITORS_TO_CANADA;
    const isTugoStudentPolicy = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_IA_TUGO_STUDENT
      || cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_TUGO_CANADIAN_STUDENT;
    const isTugoOptimum = cellCaptiveName === LIST_CELLCAPTIVE_NAME.CELL_CAPTIVE_NAME_TUGO_OPTIMUM;
    const normalizedPolicyPlanIds = Array.isArray(policyPlanIds)
      ? policyPlanIds
      : (policyPlanIds && typeof policyPlanIds.toJS === 'function' ? policyPlanIds.toJS() : []);
    const isTripCancellationTravellerPolicy = LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRIP_CANCELLATION_TRAVELLER.includes(policyTypeCode)
      || normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRIP_CANCELLATION_TRAVELLER.includes(planId));
    const isBaggageTravellerPolicy =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_BAGGAGE_TRAVELLER.includes(planId))
      || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_BAGGAGE_TRAVELLER.includes(policyTypeCode);
    const isRentalCarTravellerPolicy =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_RENTAL_CAR_TRAVELLER.includes(planId))
      || LIST_POLICY_TYPE_CODE.LIST_POLICY_PLAN_ID_SHOW_RENTAL_CAR_TRAVELLER.includes(policyTypeCode);
    const isTravellerPolicy =
      normalizedPolicyPlanIds.some((planId) => LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRAVELLER.includes(planId))
      || LIST_POLICY_TYPE_CODE.LIST_POLICY_TYPE_CODE_TRAVELLER.includes(policyTypeCode);
    const isShowProvince = isTugoStudentPolicy || isVisitorsToCanada || isTugoOptimum || isTripCancellationTravellerPolicy || isBaggageTravellerPolicy || isRentalCarTravellerPolicy || isTravellerPolicy;

    const isShowTourOperator = !showZurichUHC && !isClaimForFieldEnabled && !showTrawickFNOLRefactoring && !isTugo;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    return (
      <div className="app-content">
        {/* Only one event text at the top */}
        <div className={'row'}>
          <div className={'col-sm-12'}>
            {isScti && (
              <span className={'normal-text'}>
                <FormattedMessage className={'normal-text'} {...(isVisitorsToCanada ? messages.onlyOneEventTextVTC : messages.onlyOneEventText)} />
              </span>
            )}
            {!isScti && (
              <HelpText>
                <FormattedMessage {...(isVisitorsToCanada ? messages.onlyOneEventTextVTC : messages.onlyOneEventText)} />
              </HelpText>
            )}
            <br />
          </div>
        </div>
        {!isVisibleDuesProtect &&
          <div>
            {(!showZurichUHC && !enabledClaimSplitFeature && !showTrawickFNOLRefactoring) && isShowTourOperator &&
              <div className={'row'}>
                <div
                  className={'col-sm-6 col-md-4 form-group'}
                  style={{
                    flexGrow: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <PageSectionHeader>
                    <FormattedMessage {...messages.dateBookedTrip} />
                  </PageSectionHeader>
                  <DatePicker
                    position={'bottom-start'}
                    name="dateBookedTrip"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateBookedTrip')}
                    value={dateBookedTrip}
                    placeholder=""
                    disabled={isReadOnly}
                  />
                </div>
                <div className={'col-sm-6 col-md-4 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.dateScheduledToDepart} />
                  </PageSectionHeader>
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateScheduledToDepart"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
                    value={dateScheduledToDepart}
                    placeholder=""
                  />
                </div>
                <div className={'col-sm-6 col-md-4 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.dateOriginallyScheduled} />
                  </PageSectionHeader>
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateOriginallyScheduled"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
                    value={dateOriginallyScheduled}
                    placeholder=""
                  />
                </div>
              </div>
            }
            {showZurichUHC &&
              <div className={'row'}>
                <div
                  className={'col-sm-6 col-md-4 form-group'}
                  style={{
                    flexGrow: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <PageSectionHeader>
                    <FormattedMessage {...messages.policyPurchaseDate} />
                  </PageSectionHeader>
                  <DatePicker
                    position={'bottom-start'}
                    name="dateBookedTrip"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateBookedTrip')}
                    value={policyPurchaseDate}
                    placeholder=""
                    disabled
                  />
                </div>
                <div className={'col-sm-6 col-md-4 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.policyEffectiveDate} />
                  </PageSectionHeader>
                  <DatePicker
                    position={'bottom-start'}
                    disabled
                    name="dateScheduledToDepart"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateScheduledToDepart')}
                    value={policyEffectiveDate}
                    placeholder=""
                  />
                </div>
                <div className={'col-sm-6 col-md-4 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.policyTerminationDate} />
                  </PageSectionHeader>
                  <DatePicker
                    position={'bottom-start'}
                    disabled
                    name="dateOriginallyScheduled"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOriginallyScheduled')}
                    value={policyTerminationDate}
                    placeholder=""
                  />
                </div>
              </div>
            }
            {this.renderTripDatesSection(
              showZurichUHC,
              enabledClaimSplitFeature,
              showTrawickFNOLRefactoring,
              isReadOnly,
              dateBookedTrip,
              dateScheduledToDepart,
              dateOriginallyScheduled,
              policyPurchaseDate,
              policyEffectiveDate,
              policyTerminationDate,
            )}
            <div className={'row'}>
              {this.renderEventDateField(isReadOnly, dateOfEvent, fnolReportDateValidationStatus, checkDate, intl)}
              {this.renderEventTimeField(isReadOnly, newTimeOfEvent, fnolReportDateValidationStatus, checkTime, intl)}
            </div>


            {this.renderClaimForSection(
              isReadOnly,
              newVersion,
              enabledClaimSplitFeature,
              isClaimGroupAllowed,
              insuredsList,
              selectedClaimForList,
              isMultipleClaimFor,
              usePrimaryMemberEmailAddressForAllMember,
              usePrimaryMemberPhoneNumberForAllMember,
              intl,
            )}

            {/* Date Symptoms Started field*/}
            {isShowProvince && (
              <div className={'row'}>
                <div className={'form-group col-sm-6'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.dateSymptomsStarted} />
                  </PageSectionHeader>
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateSymptomsStarted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateSymptomsStarted')}
                    value={dateSymptomsStarted}
                    placeholder=""
                  />
                </div>
              </div>
            )}

            <div className={'row'}>
              {(newVersionCountry && isScti) && (
                <div className={isShowProvince ? 'form-group col-sm-4' : 'form-group col-sm-6'}>
                  <Validate
                    name="country"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={country}
                    fieldName={messages.country}
                    tooltipContent={intl.formatMessage({ id: 'fastCover.stepWhatHappened.countryTooltipContent' })}
                    tooltipDataFor={'countryHint'}
                    tooltipPlace={'right'}
                  >
                    <MySelect
                      dataList={countries}
                      disabled={isReadOnly}
                      onChange={(v) => {
                        this.handleChangeCountry(v);
                      }}
                      value={country}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.country}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              )}
              {(newVersionCountry && !isScti) && (
                <div className={isShowProvince ? 'form-group col-sm-4' : 'form-group col-sm-6'}>
                  <Validate
                    name="country"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={country}
                    fieldName={messages.country}
                    tooltipContent={intl.formatMessage({ id: 'fastCover.stepWhatHappened.countryTooltipContent' })}
                    tooltipDataFor={'countryHint'}
                    tooltipPlace={'right'}
                  >
                    <AsyncCreatable
                      loadOptions={this.loadCountry}
                      name="country"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      styles={{
                        input: (styles) => ({ ...styles, border: 'none !important' }),
                      }}
                      value={
                        !!selectedCountry && typeof selectedCountry.toJS === 'function' ? selectedCountry.toJS() : selectedCountry
                      }
                      placeholder={intl.formatMessage({ id: 'fastCover.stepWhatHappened.typeACountry' })}
                      isClearable
                      isDisabled={isReadOnly}
                      onChange={(e) => {
                        this.handleChangeCountry(e);
                      }}
                      defaultOptions={countries}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.country}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              )}
              {!newVersionCountry && (
                <div className={isShowProvince ? 'form-group col-sm-4' : 'form-group col-sm-6'}>
                  <Validate
                    name="country"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={country}
                    fieldName={messages.country}
                    tooltipContent={intl.formatMessage({ id: 'fastCover.stepWhatHappened.countryTooltipContent' })}
                    tooltipDataFor={'countryHint'}
                    tooltipPlace={'right'}
                  >
                    <MySelect
                      dataList={countryList}
                      disabled={isReadOnly}
                      onChange={(v) => {
                        this.handleChangeCountry(v);
                      }}
                      value={country}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.country}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              )}

              {/* Province field - VTC only */}
              {isShowProvince && provinces.length > 0 && (
                <div className={'form-group col-sm-4'}>
                  <Validate
                    name="province"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={province}
                    fieldName={messages.province}
                  >
                    <Select
                      name="province"
                      isDisabled={isReadOnly}
                      options={localizedProvinces}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable
                      onChange={(selectedOption) => {
                        this.props.onFormDataChange('form.province', selectedOption ? selectedOption.value : '');
                        this.props.onFormDataChange('form.city', '');
                        this.props.setFormHasChanges(true);
                      }}
                      value={province ? localizedProvinces.find((p) => p.value === province) || { value: province, label: province } : null}
                      placeholder={intl.formatMessage({ id: 'fastCover.stepWhatHappened.selectAProvince' })}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.province}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              )}

              {!isScti && (
                <div className={isShowProvince ? 'form-group col-sm-4' : 'form-group col-sm-6'}>
                  <Validate
                    name="city"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={city}
                    fieldName={messages.city}
                    tooltipContent={intl.formatMessage({ id: 'fastCover.stepWhatHappened.cityTooltipContent' })}
                    tooltipDataFor={'cityHint'}
                    tooltipPlace={'left'}
                  >
                    <AsyncCreatable
                      key={this.getCitySelectKey(selectedCountry, province)}
                      loadOptions={this.loadCity}
                      name="city"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      styles={{
                        input: (styles) => ({ ...styles, border: 'none !important' }),
                      }}
                      value={
                        !!city && typeof city.toJS === 'function' ? city.toJS() : city
                      }
                      placeholder={intl.formatMessage({ id: 'fastCover.stepWhatHappened.typeACity' })}
                      isClearable
                      isDisabled={!selectedCountry || isReadOnly || (provinces.length > 0 && !province && isShowProvince)}
                      onChange={(e) => {
                        this.props.onFormDataChange('form.city', e);
                        this.props.setFormHasChanges(true);
                      }}
                      defaultOptions
                      noOptionsMessage={this.cityNoOptionsMessage}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.city' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              )}


            </div>
            {(insuredsList.length > 1 && isClaimGroupAllowed) &&
              <div className={'row mt-3'}>
                <div className={'col-sm-12'}>
                  <HelpText>
                    Note : The primary claimant payment details will be used for all members you select for this claim. If you need any member to be paid to a different bank account, please go back to the Claim List screen and create a separate claim for this member.
                  </HelpText>
                </div>
              </div>
            }
            {(newVersion && insuredsList.length > 1 && !enabledClaimSplitFeature) && (<div className={'row mt-3'}>
              <div className={'form-group col-sm-6'}>
                <Validate
                  name="claimFor"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={selectedClaimForList}
                  fieldName={messages.claimFor}
                  tooltipContent={intl.formatMessage({ id: 'fastCover.stepWhatHappened.claimForTooltip' })}
                  tooltipDataFor={'claimForHint'}
                  tooltipPlace={'right'}
                >
                  <Select
                    name="claimFor"
                    isMulti
                    isDisabled={isReadOnly}
                    options={insuredsList}
                    placeholder="Select Insured(s)"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    // styles={customStyles}
                    onChange={(v) => {
                      this.handleChangeInsureds(v);
                    }}
                    value={selectedClaimForList}
                    getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                    getOptionValue={(option) => option.id}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.insureds' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>)}
            {(isMultipleClaimFor && !enabledClaimSplitFeature) && (<div className={'ml-3'}>
              <div className={'row'}>
                <div className={'form-group col-md-6'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="signature"
                      checked={usePrimaryMemberEmailAddressForAllMember === true}
                      onChange={this.handleChange('form.usePrimaryMemberEmailAddressForAllMember')}
                    />
                    <span>
                      <FormattedMessage {...messages.usePrimaryMemberEmailAddressForAllMember} />
                    </span>
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="signature"
                      checked={usePrimaryMemberPhoneNumberForAllMember === true}
                      onChange={this.handleChange('form.usePrimaryMemberPhoneNumberForAllMember')}
                    />
                    <span>
                      <FormattedMessage {...messages.usePrimaryMemberPhoneNumberForAllMember} />
                    </span>
                  </OptionsContainer>
                </div>
                <div className={'form-group col-md-6'}>
                </div>
              </div>
              {newVersion && this.renderInforInsured()}
            </div>)}
            <div className={'row'}>
              {!showTrawickFNOLRefactoring && (
                <div className={'form-group col'}>
                  <Validate
                    name="storyEvent"
                    validators={isLimitEventDescLength ? [required, maxLength(eventDescriptionLimit)] : [required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={storyEvent}
                    fieldName={!isClaimForFieldEnabled ? messages.storyEvent : messages.storyEventSCTI}
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="storyEvent"
                      type="text"
                      onChange={this.handleChange('form.storyEvent')}
                      value={storyEvent}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.storyEvent' }) }}
                      />
                    </ErrorMessage>
                  </Validate>
                  {(isLimitEventDescLength && storyEvent.length > eventDescriptionLimit) ? (
                    <P style={{ color: 'red', fontSize: '16px' }}>
                      <FormattedMessage
                        {...messages.eventDescriptionMaxLength}
                        values={{ maxEventLength: eventDescriptionLimit }}
                      />
                    </P>
                  ) : null}
                </div>
              )}
              {showTrawickFNOLRefactoring && (
                <React.Fragment>
                  <div className={'form-group col'}>
                    <Validate
                      name="tellUsWhatHappened"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={storyEvent}
                      fieldName={messages.pleaseDescribeWhatIsBeingClaimedOrWhatHappenedInDetail}
                      tooltipContent={messages.tellUsWhatHappenedTooltip.defaultMessage}
                      tooltipDataFor={'tellUsWhatHappenedHint'}
                    >
                      <TextArea
                        disabled={isReadOnly}
                        name="storyEvent"
                        type="text"
                        onChange={this.handleChange('form.storyEvent')}
                        value={storyEvent}
                        isSummary={isSummary}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.pleaseDescribeWhatIsBeingClaimedOrWhatHappenedInDetail}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                  {this.renderStoryField(
                    isReadOnly,
                    isSummary,
                    showTrawickFNOLRefactoring,
                    enabledClaimSplitFeature,
                    storyEvent,
                    intl,
                  )}
                </React.Fragment>
              )}
            </div>
            {(newVersion && !showZurichUHC && !enabledClaimSplitFeature && !showTrawickFNOLRefactoring && isShowTourOperator) && this.renderTourOperator()}
            {showZurichUHC && this.renderPurposeOfTrip()}
            {!canMoveNext && (
              <div className={'row'}>
                <div className={'col-sm-12 text-center'}>
                  <span className="font-weight-bold">
                    {intl.formatMessage({ id: 'fastCover.stepWhatHappened.youMustEnterEvent' })}
                  </span>
                </div>
              </div>
            )}
            {canMoveNext && (
              <PageSectionHeader>
                <FormattedMessage {...messages.benefitInstruction} />
                &nbsp;
                <Asterisk />{' '}
              </PageSectionHeader>
            )}
            {canMoveNext && this.renderBenefit(isReadOnly)}
          </div>
        }
        {/* Render benefit for Dues Protect */}
        {isVisibleDuesProtect &&
          <div>
            {canMoveNext && (
              <PageSectionHeader>
                <FormattedMessage {...messages.whatAreYouClaimingFor} />
                &nbsp;
                <Asterisk />{' '}
              </PageSectionHeader>
            )}
            {canMoveNext && this.renderBenefitForDuesProtect(isReadOnly)}
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="whatIsTheOutstandingDuesAmount"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={whatIsTheOutstandingDuesAmount}
                  fieldName={messages.whatIsTheOutstandingDuesAmount}
                >
                  <Textbox
                    name="whatIsTheOutstandingDuesAmount"
                    type="number"
                    onChange={this.handleChange('form.whatIsTheOutstandingDuesAmount')}
                    value={whatIsTheOutstandingDuesAmount}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepWhatHappened.whatIsTheOutstandingDuesAmount' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="currency"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={currency}
                  fieldName={messages.currency}
                >
                  <CurrencySelector
                    onChange={this.handleCurrencyChange('form.currency')}
                    disabled={isReadOnly}
                    value={currency}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.currency}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            {this.renderDuesProtectFields(isReadOnly, whatIsTheOutstandingDuesAmount, currency, intl)}
          </div>}
        {/* {
          !isSummary && (
            <div className={'row justify-content-between'}>
              <div className={'col-12 col-sm-auto'}>
                <div className={'row'}>
                  <div className={'col-12 col-sm-auto'}>
                    <button
                      className="btn-outline"
                      onClick={() => {
                        redirectTo(routeConfig.claimList);
                      }}
                      onKeyDown={this.handleKeyDown}
                    >
                      {intl.formatMessage({ id: 'fastCover.button.back' })}
                    </button>
                  </div>
                  <div className={'col-12 col-sm-auto'}>
                    <Button
                      onClick={this.handleNext}
                      onKeyDown={this.handleKeyDown}
                      innerRef={(ref) => {
                        this.nextButton = ref;
                      }}
                      disabled={submitted ? false : !canMoveNext || !list.length}
                    >
                      {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                    </Button>
                  </div>
                </div>
              </div>
              <div className={'col-12 col-sm-auto'}>
                {!submitted && (
                  <AsyncButton
                    id={this.saveButtonId}
                    className="btn-outline"
                    loading={loading}
                    spinner={this.showSpinnerForElement(this.saveButtonId)}
                    onClick={this.handleSaveButtonClick}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.save' })}
                  </AsyncButton>
                )}
              </div>
            </div>
          )
        } */}
        {!isSummary && (
          <WizardNavigationButtons
            onBack={() => {
              redirectTo(routeConfig.claimList);
            }}
            onNext={this.handleNext}
            onSave={this.handleSaveButtonClick}
            canMoveNext={canMoveNext}
            listLength={list.length}
            submitted={submitted}
            loading={loading}
            saveButtonId={this.saveButtonId}
            showSpinnerForElement={this.showSpinnerForElement}
            handleKeyDown={this.handleKeyDown}
            intl={intl}
            hasFormChanges={this.props.hasFormChanges}
            nextButtonRef={(ref) => {
              this.nextButton = ref;
            }}
          />
        )}
        <EventDateWarning
          errorMessage={this.props.errorMessage}
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          proceedAnyway={this.proceedAnyway}
        />
        <PolicyVersionChangeWarning
          isOpen={this.props.isPolicyVersionChange}
          onClose={this.closePolicyVersionChangeModal}
        />
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepWhatHappened.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  submitted: PropTypes.bool,
  isSummary: PropTypes.bool,
  adjust: PropTypes.func,
  loading: PropTypes.bool,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  step: PropTypes.number,
  fnolReportDateValidationStatus: PropTypes.any,
  countryList: PropTypes.any,
  provinceList: PropTypes.any,
  getCountryList: PropTypes.func,
  getCountriesOfxSupported: PropTypes.func,
  getCityList: PropTypes.func,
  getProvinceList: PropTypes.func,
  setToken: PropTypes.func,
  token: PropTypes.any,
  claimTypes: PropTypes.any,
  selectedBenefits: PropTypes.any,
  getClaimTypes: PropTypes.func,
  getTitleList: PropTypes.func,
  resetFormDataStepCancellationAdditional: PropTypes.func,
  resetFormDataStepPersonalItems: PropTypes.func,
  resetFormDataStepOverseasMedical: PropTypes.func,
  resetFormDataStepRentalVehicle: PropTypes.func,
  resetFormDataStepSnowSports: PropTypes.func,
  resetFormDataStepOther: PropTypes.func,
  resetFormDataStepTripCancellationAndTripInterruption: PropTypes.func,
  resetFormDataStepBaggageAndPersonalItems: PropTypes.func,
  resetFormDataStepMedicalExpenses: PropTypes.func,
  resetFormDataStepPetMedical: PropTypes.func,
  resetFormDataStepCollisionDamage: PropTypes.func,
  resetFormDataStepPropertyDamage: PropTypes.func,
  resetFormDataStepMedicalExpense: PropTypes.func,
  resetFormDataStepTripCancellation: PropTypes.func,
  resetFormDataStepTripInterruption: PropTypes.func,
  resetFormDataStepTripDelay: PropTypes.func,
  resetFormDataStepAccidentalDeathAndDismemberment: PropTypes.func,
  resetFormDataStepMissedConnection: PropTypes.func,
  resetFormDataStepBaggageAndPersonal: PropTypes.func,
  resetFormDataStepSportsEquipment: PropTypes.func,
  resetFormDataStepMedicalExpenseCF: PropTypes.func,
  resetFormDataStepMedicalExpenseZurich: PropTypes.func,
  resetFormDataStepTripCancellationCF: PropTypes.func,
  resetFormDataStepBaggagePersonalEffects: PropTypes.func,
  resetFormDataStepItineraryChange: PropTypes.func,
  resetFormDataStepMedicalHardship: PropTypes.func,
  resetFormDataStepJobLossHardship: PropTypes.func,
  resetFormDataStepDisasterAssistanceHardship: PropTypes.func,
  resetFormDataTravelDelay: PropTypes.func,
  resetFormDataMedicalAndEvacuationSCTI: PropTypes.func,
  resetFormDataChangesToYourJourneySCTI: PropTypes.func,
  resetFormDataBaggageAndPersonalItemsSCTI: PropTypes.func,
  resetFormDataPersonalAccidentSCTI: PropTypes.func,
  resetFormDataRentalVehicleExcessSCTI: PropTypes.func,
  resetFormDataCashBankCardsTravelDocumentsAndPassports: PropTypes.func,
  resetFormDataChangesToYourJourney: PropTypes.func,
  resetFormDataBaggageAndPersonalItemsStarr: PropTypes.func,
  resetFormDataOtherStarrStarr: PropTypes.func,
  resetFormCollisionDamageStarr: PropTypes.func,
  resetFormDataMedicalExpensesTugo: PropTypes.func,
  resetFormDataOtherTugo: PropTypes.func,
  resetFormDataBaseVictorsMedicalTugo: PropTypes.func,
  resetFormDataStudentMedicalBenefitsTugo: PropTypes.func,
  resetFormDataTripCancellationTugo: PropTypes.func,
  resetFormDataTripInterruptionTugo: PropTypes.func,
  resetFormDataStandardVTCMedicalBenefitsTugo: PropTypes.func,
  resetFormDataTravellerMedicalBenefitsTugo: PropTypes.func,
  resetFormDataOptimumMedicalBenefitsTugo: PropTypes.func,
  resetFormDataADAndDBenefitsTugo: PropTypes.func,
  resetFormDataTripCancellationTravellerTugo: PropTypes.func,
  resetFormDataBaggageAndPersonalItemsTravellerTugo: PropTypes.func,
  resetFormDataRentalCarProtectionTravellerTugo: PropTypes.func,
  setSelectedPolicyId: PropTypes.func,
  removeFileSuccess: PropTypes.func,
  makeSelectStepSupportingDocuments: PropTypes.any,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  policyNumber: PropTypes.any,
  path: PropTypes.any,
  errors: PropTypes.any,
  isReadOnly: PropTypes.any,
  appClaimTypes: PropTypes.array,
  errorMessage: PropTypes.string,
  checkValidationDateOfEvent: PropTypes.func,
  setErrorMessageDateValidation: PropTypes.func,
  isPolicyVersionChange: PropTypes.bool,
  policyVersionChanged: PropTypes.func,
  deleteDocumentsByBenefitCode: PropTypes.func,
  jsonVersion: PropTypes.string,
  insuredsList: PropTypes.any,
  emailAddressLogin: PropTypes.string,
  phoneNumberLogin: PropTypes.string,
  isClaimGroupAllowed: PropTypes.bool,
  showZurichUHC: PropTypes.bool,
  policyPurchaseDate: PropTypes.any,
  policyEffectiveDate: PropTypes.any,
  policyTerminationDate: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  policyTypeCode: PropTypes.string,
  policyPlanIds: PropTypes.any,
  showTrawickFNOLRefactoring: PropTypes.bool,
  eventDescriptionLimit: PropTypes.any,
  getDepreciationTypes: PropTypes.any,
  intl: intlShape.isRequired,
  cellCaptiveName: PropTypes.string,
  hasFormChanges: PropTypes.bool,
  setFormHasChanges: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepWhatHappened(),
  loading: makeSelectProgressBarStatus(),
  fnolReportDateValidationStatus: makeSelectFnolReportDateValidation(),
  countryList: makeSelectCountryList(),
  provinceList: makeSelectProvinceList(),
  claimTypes: makeSelectClaimTypeList(),
  makeSelectStepSupportingDocuments: makeSelectStepSupportingDocuments(),
  currentStep: makeSelectCurrentStep(),
  appClaimTypes: makeSelectAppClaimType(),
  errorMessage: makeSelectValidationDateErrorMessage(),
  isPolicyVersionChange: makeSelectPolicyVersionChanged(),
  jsonVersion: makeSelectJSONVersion(),
  isLinkedCover: makeSelectIsLinkedCover(),
  emailAddressLogin: makeSelectEmailAddressLogin(),
  phoneNumberLogin: makeSelectPhoneNumberLogin(),
  isClaimGroupAllowed: makeSelectIsClaimGroupAllowed(),
  showZurichUHC: makeSelectShowZurichUHC(),
  policyPurchaseDate: makeSelectPolicyPurchaseDate(),
  policyEffectiveDate: makeSelectPolicyEffectiveDate(),
  policyTerminationDate: makeSelectPolicyTerminationDate(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  policyTypeCode: makeSelectPolicyTypeCode(),
  policyPlanIds: makeSelectPolicyPlanIds(),
  carrierName: makeSelectCarrier(),
  showTrawickFNOLRefactoring: makeSelectShowTrawickFNOLRefactoring(),
  eventDescriptionLimit: makeSelectEventDescriptionLimit(),
  cellCaptiveName: makeSelectCellCaptiveName(),
  hasFormChanges: makeSelectFormHasChanges(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onResetClaimToInjuryState: () => dispatch(resetFormClaimToInjuryState()),
  onResetDetailOfMedicalConditional: () =>
    dispatch(resetDetailOfMedicalConditional()),
  getCountryList: () => dispatch(getCountryList()),
  getCountriesOfxSupported: () => dispatch(getCountriesOfxSupported()),
  getCityList: (stringCity, callback) =>
    dispatch(getCityList(stringCity, callback)),
  getProvinceList: () => dispatch(getProvinceList()),
  setToken: (t) => dispatch(setAuthenticationToken(t)),
  getClaimTypes: () => dispatch(getClaimTypes()),
  getTitleList: () => dispatch(getTitleList()),
  getDepreciationTypes: () => dispatch(getDepreciationTypes()),
  resetFormDataStepCancellationAdditional: () => dispatch(resetFormDataStepCancellationAdditional()),
  resetFormDataStepPersonalItems: () => dispatch(resetFormDataStepPersonalItems()),
  resetFormDataStepOverseasMedical: () => dispatch(resetFormDataStepOverseasMedical()),
  resetFormDataStepRentalVehicle: () => dispatch(resetFormDataStepRentalVehicle()),
  resetFormDataStepSnowSports: () => dispatch(resetFormDataStepSnowSports()),
  resetFormDataStepOther: () => dispatch(resetFormDataStepOther()),
  resetFormDataStep16: () => dispatch(resetFormDataStep16()),
  resetFormDataStep17: () => dispatch(resetFormDataStep17()),
  resetFormDataStepTripCancellationAndTripInterruption: () => dispatch(resetFormDataStepTripCancellationAndTripInterruption()),
  resetFormDataStepBaggageAndPersonalItems: () => dispatch(resetFormDataStepBaggageAndPersonalItems()),
  resetFormDataStepMedicalExpenses: () => dispatch(resetFormDataStepMedicalExpenses()),
  resetFormDataStepPetMedical: () => dispatch(resetFormDataStepPetMedical()),
  resetFormDataStepCollisionDamage: () => dispatch(resetFormDataStepCollisionDamage()),
  resetFormDataStepPropertyDamage: () => dispatch(resetFormDataStepPropertyDamage()),
  resetFormDataStepMedicalExpense: () => dispatch(resetFormDataStepMedicalExpense()),
  resetFormDataStepTripCancellation: () => dispatch(resetFormDataStepTripCancellation()),
  resetFormDataStepTripInterruption: () => dispatch(resetFormDataStepTripInterruption()),
  resetFormDataStepTripDelay: () => dispatch(resetFormDataStepTripDelay()),
  resetFormDataStepAccidentalDeathAndDismemberment: () => dispatch(resetFormDataStepAccidentalDeathAndDismemberment()),
  resetFormDataStepMissedConnection: () => dispatch(resetFormDataStepMissedConnection()),
  resetFormDataStepBaggageAndPersonal: () => dispatch(resetFormDataStepBaggageAndPersonal()),
  resetFormDataStepSportsEquipment: () => dispatch(resetFormDataStepSportsEquipment()),
  resetFormDataStepMedicalExpenseCF: () => dispatch(resetFormDataStepMedicalExpenseCF()),
  resetFormDataStepMedicalExpenseZurich: () => dispatch(resetFormDataStepMedicalExpenseZurich()),
  resetFormDataStepTripCancellationCF: () => dispatch(resetFormDataStepTripCancellationCF()),
  resetFormDataStepBaggagePersonalEffects: () => dispatch(resetFormDataStepBaggagePersonalEffects()),
  resetFormDataStepItineraryChange: () => dispatch(resetFormDataStepItineraryChange()),
  resetFormDataStepMedicalHardship: () => dispatch(resetFormDataStepMedicalHardship()),
  resetFormDataStepJobLossHardship: () => dispatch(resetFormDataStepJobLossHardship()),
  resetFormDataStepDisasterAssistanceHardship: () => dispatch(resetFormDataStepDisasterAssistanceHardship()),
  resetFormDataTravelDelay: () => dispatch(resetFormDataTravelDelay()),
  resetFormDataMedicalAndEvacuationSCTI: () => dispatch(resetFormDataMedicalAndEvacuationSCTI()),
  resetFormDataChangesToYourJourneySCTI: () => dispatch(resetFormDataChangesToYourJourneySCTI()),
  resetFormDataBaggageAndPersonalItemsSCTI: () => dispatch(resetFormDataBaggageAndPersonalItemsSCTI()),
  resetFormDataPersonalAccidentSCTI: () => dispatch(resetFormDataPersonalAccidentSCTI()),
  resetFormDataRentalVehicleExcessSCTI: () => dispatch(resetFormDataRentalVehicleExcessSCTI()),
  resetFormDataCashBankCardsTravelDocumentsAndPassports: () => dispatch(resetFormDataCashBankCardsTravelDocumentsAndPassports()),
  resetFormDataChangesToYourJourney: () => dispatch(resetFormDataChangesToYourJourney()),
  resetFormDataBaggageAndPersonalItemsStarr: () => dispatch(resetFormDataBaggageAndPersonalItemsStarr()),
  resetFormDataOtherStarrStarr: () => dispatch(resetFormDataOtherStarrStarr()),
  resetFormCollisionDamageStarr: () => dispatch(resetFormCollisionDamageStarr()),
  resetFormDataMedicalExpensesTugo: () => dispatch(resetFormDataMedicalExpensesTugo()),
  resetFormDataOtherTugo: () => dispatch(resetFormDataOtherTugo()),
  resetFormDataBaseVictorsMedicalTugo: () => dispatch(resetFormDataBaseVictorsMedicalTugo()),
  resetFormDataStudentMedicalBenefitsTugo: () => dispatch(resetFormDataStudentMedicalBenefitsTugo()),
  resetFormDataTripCancellationTugo: () => dispatch(resetFormDataTripCancellationTugo()),
  resetFormDataTripCancellationTravellerTugo: () => dispatch(resetFormDataTripCancellationTravellerTugo()),
  resetFormDataTripInterruptionTugo: () => dispatch(resetFormDataTripInterruptionTugo()),
  resetFormDataStandardVTCMedicalBenefitsTugo: () => dispatch(resetFormDataStandardVTCMedicalBenefitsTugo()),
  resetFormDataTravellerMedicalBenefitsTugo: () => dispatch(resetFormDataTravellerMedicalBenefitsTugo()),
  resetFormDataOptimumMedicalBenefitsTugo: () => dispatch(resetFormDataOptimumMedicalBenefitsTugo()),
  resetFormDataADAndDBenefitsTugo: () => dispatch(resetFormDataADAndDBenefitsTugo()),
  resetFormDataBaggageAndPersonalItemsTravellerTugo: () => dispatch(resetFormDataBaggageAndPersonalItemsTravellerTugo()),
  resetFormDataRentalCarProtectionTravellerTugo: () => dispatch(resetFormDataRentalCarProtectionTravellerTugo()),
  setSelectedPolicyId: (policyId) => dispatch(setSelectedPolicyId(policyId)),
  removeFileSuccess: (f) => dispatch(removeFileSuccess(f)),
  checkValidationDateOfEvent: (fieldName) =>
    dispatch(checkValidationDateOfEvent(fieldName)),
  setErrorMessageDateValidation: (message) =>
    dispatch(setErrorMessageDateValidation(message)),
  policyVersionChanged: (value) => dispatch(policyVersionChanged(value)),
  deleteDocumentsByBenefitCode: (value) => dispatch(deleteDocumentsByBenefitCode(value)),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'stepWhatHappened', reducer });
const withSaga = injectSaga({ key: 'stepWhatHappened', saga });

export default compose(withReducer, withSaga, injectIntl, withConnect)(StepWhatHappened);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepWhatHappened/index.js